<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card card-w-title">
        <div class="manager-title">Quản lý sửa chữa - bảo hành - bảo trì</div>
      </div>
      <div class="card card-w-title" v-if="$myConstants.checkRoleGroup('warranty_repair', 'view')">
        <div class="box-top-list">

          <span class="p-m-0">Thông tin sản phẩm sữa chữa - bảo hành - bảo trì</span>
          <span class="right-button">
            <Button class="p-button-warning" :label="'Quay lại'" @click="backList"  /><!--@click="backList"-->
            <Button
                v-if="!this.$myConstants.isEmpty(objectData.process_status) && objectData.process_status == 0"
                :disabled="submitForm"
                class="p-button-success btn-custom"
                :label="'Lưu'"
                @click="saveData(true)" /><!--@click="saveData"-->
            <Button
                v-if="!this.$myConstants.isEmpty(objectData.process_status) && objectData.process_status == 0"
                class="btn-custom"
                :label="'Đã xong'"
                type="button"
                @click="saveData(false)"
            > </Button><!-- @click="saveData"-->
          </span>
        </div>
        <div class="list-data">
          <TabView >
            <TabPanel :key="'0'"   header="Thông tin dịch vụ" >
              <div class="p-fluid p-formgrid p-grid">
                <div class="p-col-12" >
                  <div class="p-grid">
                    <div class="p-field p-col-12 p-md-6"  >
                      <div class="p-col-12">
                        <div class="title_group">KIỂM TRA SẢN PHẨM</div>
                      </div>
                    </div>
                    <div class="p-field p-col-12 p-md-6" >
                    </div>
                  </div>
                </div>
                <div class="p-col-12" >
                  <div class="p-grid">
                    <div class="p-field p-col-12 p-md-6"  >
                      <div class="p-col-12">
                        <div class="p-fluid p-formgrid p-grid">
                          <div class="p-field p-col">
                            <label class="style_lable">Loại dịch vụ<span class="error">*</span></label>
                            <Dropdown :disabled="disable_all || objectData.check_type_service == $dataCommon.WARRANTY_REPAIR.TYPE_SERVICE.REPAIR_APPRAISAL " v-model="objectData.check_type_service" :options="list_type_service" optionLabel="label" optionValue="value" placeholder="Chọn loại dịch vụ" />
                            <small v-if="validationErrors && validationErrors['check_type_service']" class="p-invalid">{{ validationErrors['check_type_service'] }}</small>
                          </div>
                          <div class="p-field p-col" >
                            <div v-if="(!$myConstants.isEmpty(objectData.check_type_service)) && objectData.check_type_service=='T07'">
                              <label >Đợt bảo trì<span class="error">*</span></label>
                              <Dropdown :disabled="disable_all" v-model="objectData.check_maintenance_period"  :options="list_maintenance_sessions"  optionValue="id" optionLabel="lable"  @change="changeMaintence" />
                              <small v-if="validationErrors && validationErrors['check_maintenance_period']" class="p-invalid">{{ validationErrors['check_maintenance_period'] }}</small>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="p-col-12">
                        <label class="style_lable">Hiện tượng hư hỏng<span class="error">*</span></label>
                        <Textarea :disabled="disable_all" maxlength="5000" class="style_input_common" rows="5" v-model="objectData.check_presently_damaged" :autoResize="true"/>
                        <small v-if="validationErrors && validationErrors['check_presently_damaged']" class="p-invalid">{{ validationErrors['check_presently_damaged'] }}</small>
                      </div>
                      <div class="p-col-12" style="padding-bottom: 0px">
                            <label class="style_lable">Kết quả kiểm tra<span class="error">*</span></label>
                      </div>
                      <div class="p-col-12" style="padding-top: 0px">
                        <div class="p-fluid p-formgrid p-grid">
                          <div class="p-col-4">
                          <div class="p-field p-col">
                            <div class="group_radio_button">
                              <div class="p-field-radiobutton radio_product_apply">
                                <RadioButton :disabled="disable_all" id="product_apply_1" name="city" value="0" v-model="objectData.check_result" @change="changeResult" />
                                <label for="product_apply_1" class="radio_lable_product_apply">Thực hiện dịch vụ</label>
                              </div>
                              <div class="p-field-radiobutton radio_product_apply" style="margin-top: 8px;">
                                <RadioButton :disabled="disable_all" id="product_apply_2" name="city" value="2" v-model="objectData.check_result" @change="changeResult"/>
                                <label for="product_apply_2" class="radio_lable_product_apply">Hỏi ý kiến khách hàng</label>
                              </div>
                            </div>
                          </div>
                          </div>
                          <div class="p-col-8">
                          <div class="p-field p-col" >
                            <div >
                              <div class="group_radio_button">
                                <div class="p-field-radiobutton radio_product_apply">
                                  <RadioButton :disabled="disable_all" id="product_apply_1" name="city" value="1" v-model="objectData.check_result" @change="changeResult"/>
                                  <label for="product_apply_1" class="radio_lable_product_apply">Không thực hiện và gửi trả khách hàng</label>
                                </div>
                                <div class="p-field-radiobutton radio_product_apply" style="margin-top: 8px;">
                                  <RadioButton :disabled="disable_all" id="product_apply_2" name="city" value="3" v-model="objectData.check_result" @change="changeResult"/>
                                  <label for="product_apply_2" class="radio_lable_product_apply">Không sửa chữa và đề nghị hủy sản phẩm</label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        </div>
                        <small v-if="validationErrors && validationErrors['check_result']" class="p-invalid">{{ validationErrors['check_result'] }}</small>
                      </div>
                      <div class="p-col-12" v-if="objectData.check_result == '1'">
                        <label class="style_lable">Lý do không sửa chữa<span class="error">*</span></label>
                        <Textarea :disabled="disable_all" maxlength="1000" class="style_input_common"  rows="1" v-model="objectData.check_reason_not_repairing" :autoResize="true"/>
                        <small v-if="validationErrors && validationErrors['check_reason_not_repairing']" class="p-invalid">{{ validationErrors['check_reason_not_repairing'] }}</small>
                      </div>
                      <div class="p-col-12" v-if="objectData.check_result == '3'">
                        <label class="style_lable">Lý do đề nghị hủy sản phẩm<span class="error">*</span></label>
                        <Textarea :disabled="disable_all" maxlength="1000" class="style_input_common"  rows="1" v-model="objectData.check_reason_cancel_product" :autoResize="true"/>
                        <small v-if="validationErrors && validationErrors['check_reason_cancel_product']" class="p-invalid">{{ validationErrors['check_reason_cancel_product'] }}</small>
                      </div>
                      <div class="p-col-12" v-if="objectData.check_result == '2'">
                        <div>
                          <label class="style_lable p-col-6" style="float: left" >Nội dung hỏi khách hàng<span class="error">*</span></label>
                          <div class="p-col-6 box_radio_reply" >
                            <div class="p-col-12" >
                              <div class="p-grid">
                            <div class="p-col-6" >
                            <div class="p-field-radiobutton ">
                              <RadioButton :disabled="disable_all"  name="city" value="1" class="style_radio" v-model="objectData.check_is_customer_reply"  />
                              <label for="product_apply_1" class="lable_reply" >Đồng ý</label>
                            </div>
                            </div>
                            <div class="p-col-6" >
                              <div class="p-field-radiobutton " >
                                <RadioButton :disabled="disable_all"  name="city" value="0" class="style_radio"  v-model="objectData.check_is_customer_reply" />
                                <label for="product_apply_1" class="lable_reply" >Từ chối</label>
                              </div>
                            </div>
                              </div>
                            </div>
                            <small style="padding-left: 10px; padding-top: 8px;" v-if="validationErrors && validationErrors['check_is_customer_reply']"  class="p-invalid">{{ validationErrors['check_is_customer_reply'] }}</small>
                          </div>
                        </div>
                        <Textarea :disabled="disable_all" maxlength="1000" class="style_input_common" rows="1" v-model="objectData.check_content_ask_customer" :autoResize="true"/>
                        <small v-if="validationErrors && validationErrors['check_content_ask_customer']" class="p-invalid">{{ validationErrors['check_content_ask_customer'] }}</small>
                      </div>

                    </div>
                    <div class="p-field p-col-12 p-md-6" >
                      <div class="p-col-12">
                        <div class="p-fluid p-formgrid p-grid">
                          <div class="p-field p-col">
                            <label class="style_lable">Loại nguyên nhân hư hỏng<!--<span class="error">*</span>--></label>
                            <Dropdown :disabled="disable_all" class="width-300" :filter="true" v-model="objectData.check_type_failure_cause_id"  :options="list_type_failure_cause" optionLabel="name" optionValue="id" placeholder="Chọn loại nguyên nhân hư hỏng"/>
                            <small v-if="validationErrors && validationErrors['check_type_failure_cause_id']" class="p-invalid">{{ validationErrors['check_type_failure_cause_id'] }}</small>
                          </div>
                          <div class="p-field p-col">
                            <label class="style_lable">Nhân viên kỹ thuật<span class="error">*</span></label>
                            <Dropdown :disabled="disable_all"  class="width-300" :filter="true"  v-model="objectData.check_technical_user_id" :options="list_technical_user" optionLabel="full_name" optionValue="id"   placeholder="Chọn nhân viên kỹ thuật"></Dropdown>
<!--                            <v-select :filterable="false" placeholder="Chọn nhân viên kỹ thuật" v-model="objectData.check_technical_user_id"  :options="list_technical_user" :reduce="list_technical_user => districts.id"  label="full_name" @search="fetchOptionsDistrict" @input="changeDistrict">
                  <span slot="no-options" @click="$refs.select.open = false">
                  {{ $dataCommon.TEXT_NOT_FIND_DATA_SELECT }}
                </span>
                            </v-select>-->
                            <small  v-if="validationErrors && validationErrors['check_technical_user_id'] " class="p-invalid" >{{validationErrors['check_technical_user_id']}}</small>
                          </div>
                        </div>
                      </div>
                      <div class="p-col-12">
                        <label class="style_lable">Nguyên nhân hư hỏng<!--<span class="error">*</span>--></label>
                        <Textarea :disabled="disable_all" maxlength="5000" class="style_input_common"  rows="5" v-model="objectData.check_cause_damage" :autoResize="true"/>
                        <small v-if="validationErrors && validationErrors['check_cause_damage']" class="p-invalid">{{ validationErrors['check_cause_damage'] }}</small>
                      </div>
                      <div class="p-col-12">
                        <label class="style_lable">Giải pháp đề xuất</label>
                        <Textarea :disabled="disable_all" maxlength="5000" class="style_input_common" rows="5" v-model="objectData.check_proposed_solutions" :autoResize="true"/>
                      </div>

                    </div>
                  </div>
                </div>

                <div class="p-col-12" v-if="objectData.check_result == '0' || (objectData.check_result == '2')" >
                  <div class="p-grid">
                    <div class="p-field p-col-12 p-md-6">
                      <!--<div class="p-col-12">-->
                      <label for="name" class="style_lable">DANH SÁCH DỊCH VỤ SỬA CHỮA - BẢO HÀNH - BẢO TRÌ</label>
                      <form v-on:submit.prevent="noop" v-if="disable_all == false" >
                        <div class="p-fluid p-formgrid p-grid box_add_option" style="">
                          <div class="box_input" style="">
                            <div class="p-field box_title" style="">
                              <label class="title_input" style="">Gói dịch vụ</label>
                              <!--<a href="#"
                                 v-on:click="onActionClickedAddServiceSupplies($event,{action: {name: 'add', label: 'Tạo mới'}, key: 'add'})"><label
                                  class="add_service_supplies" style="">+ Tạo mới vật tư - dịch vụ</label></a>-->
                            </div>
                            <Dropdown :key="service_pack_key" class="width-300" :filter="true" v-model="object_service_park.selected_service_park"
                                      :options="object_service_park.list_service_park" optionLabel="lable"
                                      placeholder="Chọn dịch vụ"><!--optionValue="id" -->
                            </Dropdown>
                          </div>
                          <button class="add_btn_data" style="" @click="add_service_park()">
                            <img class="style_icon_add" style="" src="../../../../public/assets/images/playlist_add_u605.png"/>
                            <span class="style_text" style="">Thêm</span>
                          </button>
                        </div>
                      </form>

                      <form style="margin-top: 10px;" v-on:submit.prevent="noop" v-if="disable_all == false" >
                        <div class="p-fluid p-formgrid p-grid box_add_option" style="">
                          <div class="box_input" style="">
                            <div class="p-field box_title" style="">
                              <label class="title_input" style="">Vật tư lẻ</label>
                              <!--<a href="#"
                                 v-on:click="onActionClickedAddServiceSupplies($event,{action: {name: 'add', label: 'Tạo mới'}, key: 'add'})"><label
                                  class="add_service_supplies" style="">+ Tạo mới vật tư - dịch vụ</label></a>-->
                            </div>
                            <Dropdown :key="retail_supplies_key" class="width-300" :filter="true" v-model="object_service_park.selected_retail_supplies"
                                      :options="object_service_park.list_retail_supplies" optionLabel="lable"
                                      placeholder="Chọn vật tư"><!--optionValue="id" -->
                            </Dropdown>
                          </div>
                          <button class="add_btn_data" style="" @click="add_retail_supplies()">
                            <img class="style_icon_add" style="" src="../../../../public/assets/images/playlist_add_u605.png"/>
                            <span class="style_text" style="">Thêm</span>
                          </button>
                        </div>
                      </form>
                      <small v-if="validationErrors && validationErrors['list_product_service_park']" class="p-invalid">{{ validationErrors['list_product_service_park'] }}</small>
                    </div>
                    <div class="p-field p-col-12 12">
                      <div class="p-col-12 list_service_park_price">
                    <DataTable
                        dataKey="id"
                        class="p-datatable-responsive"
                        :scrollable="(object_service_park.scrollHeight !== '' ? true : false) "
                        :scrollHeight="object_service_park.scrollHeight"
                        :autoLayout="true"
                        :value="object_service_park.list_product_service_park"

                    ><!--responsiveLayout="scroll"-->
                      <Column
                          :bodyStyle="'width: 23em;'"
                          :headerStyle="'width: 23em;'"
                          :headerClass="object_service_park.headerClass"
                          field="lable" header="Danh mục dịch vụ sửa chữa">
                        <template #body="slotProps">
                          <div v-if="(slotProps.data.is_parent == true ) || (slotProps.data.is_parent==false && slotProps.data.service_pack_id==-1)">
                            <div :style="style_lable(slotProps.data)" >{{ slotProps.data.lable }}</div>
                            <div  v-if="disable_all == false && !(slotProps.data.is_parent == true  && slotProps.data.service_pack_id==-1) " style="width: 100px;float: right;text-align: right;"><a href="#" v-on:click="delete_service_park($event,slotProps)" style="color: #FF0000">(Xóa)</a></div>
                          </div>
                          <div style="padding-left: 16px" v-else>
                            {{ slotProps.data.lable }}
                          </div>
                        </template>
                      </Column>
                      <Column
                          :bodyStyle="'width: 100px;text-align: center;'"
                          :headerStyle="'width: 100px;text-align: center;'"
                          :headerClass="object_service_park.headerClass"
                          field="is_parent" header="Đơn vị tính">
                        <template #body="slotProps">
                          <div v-if="slotProps.data.is_parent == false">
                            {{ (!$myConstants.isEmpty(slotProps.data.unit_name)) ? slotProps.data.unit_name:''}}
                          </div>
                        </template>
                      </Column>
                      <Column
                          :bodyStyle="'width: 100px;text-align: center;'"
                          :headerStyle="'width: 100px;text-align: center;'"
                          :headerClass="object_service_park.headerClass"
                          field="is_free" header="Miễn phí">
                        <template #body="slotProps">
                          <div v-if="disable_all == true">
                            <img v-if="slotProps.data.is_free == true" :src="icon_check" style="width: 24px;height: 24px">
                          </div>
                          <div v-else>
                            <Checkbox :disabled="disable_all" @change="change_is_free(slotProps,'is_free')" v-model="slotProps.data.is_free" :binary="true" />
                          </div>
                        </template>
                      </Column>
                      <Column
                          :bodyStyle="'width: 140px;text-align: right;'"
                          :headerStyle="'width: 140px;text-align: right;'"
                          :headerClass="object_service_park.headerClass"
                          field="unit_price_text" header="Đơn giá (VNĐ)">
                        <template #body="slotProps">
                          <div>
                            {{ slotProps.data.unit_price_text }}
                          </div>
                        </template>
                      </Column>
                      <Column
                          :bodyStyle="'width: 110px;text-align: center;'"
                          :headerStyle="'width: 110px;text-align: center;'"
                          :headerClass="object_service_park.headerClass"
                          field="number" header="Số lượng">
                        <template #body="slotProps">
                          <div v-if="slotProps.data.is_parent == false">
                            <InputNumber v-if="disable_all == false" :min="-1" :max="10000000000" :class="'style_input_number_common'"  v-model="slotProps.data.number" @keyup="change_data_table(slotProps,'number')"  style="width: 100%;text-align: right" mode="decimal" locale="de-DE" :minFractionDigits="0" /><!--locale="en-US" -->
                            <div style="text-align: right" v-if="disable_all == true">{{ (!$myConstants.isEmpty(slotProps.data.number)) ? $myConstants.numberFormat(parseFloat(slotProps.data.number), 0, '', '.'):0  }}</div>
                            <!--<div style="height: 14px;">
                              <small v-if="slotProps.data.number_err" class="p-invalid">{{ slotProps.data.number_err }}</small>
                            </div>-->
                          </div>
                        </template>
                      </Column>
                      <Column
                          :bodyStyle="'width: 110px;text-align: center;'"
                          :headerStyle="'width: 110px;text-align: center;'"
                          :headerClass="object_service_park.headerClass"
                          field="discount" header="% Giảm giá">
                        <template #body="slotProps">
                          <div v-if="slotProps.data.is_parent == false">
                            <InputNumber v-if="disable_all == false" :min="-1" :max="101" :class="'style_input_number_common'"  v-model="slotProps.data.discount" @keyup="change_data_table(slotProps,'discount')"  style="width: 100%;text-align: right" mode="decimal" locale="en-US" :minFractionDigits="1" />
                            <div style="text-align: right" v-if="disable_all == true">{{slotProps.data.discount}}</div>
                            <!--<div style="height: 14px;">
                              <small v-if="slotProps.data.discount_err" class="p-invalid">{{ slotProps.data.discount_err }}</small>
                            </div>-->
                          </div>
                        </template>
                      </Column>
                      <Column
                          :bodyStyle="'width: 140px;text-align: center;'"
                          :headerStyle="'width: 140px;text-align: center;'"
                          :headerClass="object_service_park.headerClass"
                          field="money_discount" header="Tiền giảm giá">
                        <template #body="slotProps">
                          <div v-if="slotProps.data.is_parent == false">
                            <InputNumber v-if="disable_all == false" :min="-1" :max="10000000000" :class="'style_input_number_common'"  v-model="slotProps.data.money_discount" @keyup="change_data_table(slotProps,'money_discount')"  style="width: 100%;text-align: right" mode="decimal" locale="de-DE" :minFractionDigits="0" />
                            <div style="text-align: right" v-if="disable_all == true">{{ (!$myConstants.isEmpty(slotProps.data.money_discount)) ? $myConstants.numberFormat(parseFloat(slotProps.data.money_discount), 0, '', '.'):0  }}</div>
                            <!--<div style="height: 14px;">
                              <small v-if="slotProps.data.money_discount_err" class="p-invalid">{{ slotProps.data.money_discount_err }}</small>
                            </div>-->
                          </div>
                        </template>
                      </Column>
                      <Column
                          :bodyStyle="'width: 140px;text-align: right;'"
                          :headerStyle="'width: 140px;text-align: right;'"
                          :headerClass="object_service_park.headerClass"
                          field="total_price" header="Tổng cộng">
                        <template #body="slotProps">
                          <div :style="(slotProps.data.is_parent == true) ? 'font-weight: 700;':''">
                            {{ (!$myConstants.isEmpty(slotProps.data.total_price)) ? $myConstants.numberFormat(parseFloat(slotProps.data.total_price), 0, '', '.'):0  }}
                          </div>
                        </template>
                      </Column>
                      <ColumnGroup v-if="object_service_park.list_product_service_park.length > 0" type="footer">
                        <Row >
                          <Column :footerClass="object_service_park.footerClass" :colspan="7" >
                            <template #footer="{}" >
                              <div class="header_footer">Tổng cộng</div>
                            </template>
                          </Column>
                          <Column :footerClass="object_service_park.footerClass" :colspan="1" >
                            <template #footer="{}" >
                              <div class="value_common_footer">
                                {{ (!$myConstants.isEmpty(object_service_park.service_total_price_service)) ? $myConstants.numberFormat(parseFloat(object_service_park.service_total_price_service), 0, '', '.'):0  }}
                              </div>
                            </template>
                          </Column>
                        </Row>
                        <Row >
                          <Column :footerClass="object_service_park.footerClass" :colspan="7" >
                            <template #footer="{}" >
                              <div class="header_footer">% Giảm giá</div>
                            </template>
                          </Column>
                          <Column :footerClass="object_service_park.footerClass" :colspan="1" >
                            <template #footer="{}" >
                              <div class="value_common_footer">
                                <InputNumber v-if="disable_all == false" :min="-1" :max="101" :class="'style_input_number_common'"  @keyup="change_data_footer('service_total_discount')" style="width: 100%;text-align: right" v-model="object_service_park.service_total_discount" mode="decimal" locale="en-US" :minFractionDigits="1" />
                                <div class="style_value" v-if="disable_all == true">{{object_service_park.service_total_discount}}</div>
                              </div>
                            </template>
                          </Column>
                        </Row>
                        <Row >
                          <Column :footerClass="object_service_park.footerClass" :colspan="7" >
                            <template #footer="{}" >
                              <div class="header_footer">Tiền giảm giá</div>
                            </template>
                          </Column>
                          <Column :footerClass="object_service_park.footerClass" :colspan="1" >
                            <template #footer="{}" >
                              <div class="value_common_footer">
                                <InputNumber v-if="disable_all == false" :min="-1" :max="10000000000" :class="'style_input_number_common'"  @keyup="change_data_footer('service_total_money_discount')" style="width: 100%;text-align: right"  v-model="object_service_park.service_total_money_discount" mode="decimal" locale="de-DE" :minFractionDigits="0" />
                                <div class="style_value" v-if="disable_all == true">
                                  {{ (!$myConstants.isEmpty(object_service_park.service_total_money_discount)) ? $myConstants.numberFormat(parseFloat(object_service_park.service_total_money_discount), 0, '', '.'):0  }}
                                </div>
                              </div>
                            </template>
                          </Column>
                        </Row>
                        <Row >
                          <Column :footerClass="object_service_park.footerClass" :colspan="7" >
                            <template #footer="{}" >
                              <div class="header_footer">%Thuế GTGT</div>
                            </template>
                          </Column>
                          <Column :footerClass="object_service_park.footerClass" :colspan="1" >
                            <template #footer="{}" >
                              <div class="value_common_footer">
                                <!--<input @keyup="change_data_footer('service_tax')" style="width: 100%;text-align: right" type="number" v-model="object_service_park.service_tax">-->
                                <InputNumber v-if="disable_all == false" :min="-1" :max="101" :class="'style_input_number_common'"  @keyup="change_data_footer('service_tax')" style="width: 100%;text-align: right"  v-model="object_service_park.service_tax" mode="decimal" locale="en-US" :minFractionDigits="1" />
                                <div class="style_value" v-if="disable_all == true">{{object_service_park.service_tax}}</div>
                              </div>
                            </template>
                          </Column>
                        </Row>
                        <Row >
                          <Column :footerClass="object_service_park.footerClass" :colspan="7" >
                            <template #footer="{}" >
                              <div class="header_footer">Tiền thuế GTGT</div>
                            </template>
                          </Column>
                          <Column :footerClass="object_service_park.footerClass" :colspan="1" >
                            <template #footer="{}" >
                              <div class="value_common_footer">
                                <InputNumber v-if="disable_all == false" :class="'style_input_number_common'"  :disabled="true" style="width: 100%;text-align: right"  v-model="object_service_park.service_money_tax" mode="decimal" locale="de-DE" :minFractionDigits="0" />
                                <div class="style_value" v-if="disable_all == true">
                                  {{ (!$myConstants.isEmpty(object_service_park.service_money_tax)) ? $myConstants.numberFormat(parseFloat(object_service_park.service_money_tax), 0, '', '.'):0  }}
                                </div>
                              </div>
                            </template>
                          </Column>
                        </Row>
                        <Row >
                          <Column :footerClass="object_service_park.footerClass" :colspan="7" >
                            <template #footer="{}" >
                              <div class="header_footer">Thành tiền</div>
                            </template>
                          </Column>
                          <Column :footerClass="object_service_park.footerClass" :colspan="1" >
                            <template #footer="{}" >
                              <div class="value_common_footer">
                                {{ (!$myConstants.isEmpty(object_service_park.service_total_price_payment)) ? $myConstants.numberFormat(parseFloat(object_service_park.service_total_price_payment), 0, '', '.'):0  }}
                              </div>
                            </template>
                          </Column>
                        </Row>
                      </ColumnGroup>
                      <template #empty>
                        Không có dữ liệu
                      </template>
                    </DataTable>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="p-col-12" >
                  <div class="p-grid">
                    <div class="p-field p-col-12 p-md-6"  >
                      <div class="p-col-12">
                        <label class="style_lable">Ý KIẾN NHÂN VIÊN VỀ SỬ DỤNG SẢN PHẨM</label>
                        <Textarea :disabled="disable_all" class="style_input_common" rows="5" v-model="objectData.check_staff_comments" :autoResize="true"/>
                      </div>
                    </div>
                    <div class="p-field p-col-12 p-md-6" >
                      <div class="p-col-12">
                        <label class="style_lable">BIÊN BẢN XÁC NHẬN CỦA KHÁCH HÀNG</label>
                        <div class="p-field">
                          <Button :disabled="disable_all" :label="'Chọn'" icon="pi pi-plus" @click="openFile" />
                          <input :disabled="disable_all" id="files" ref="files" type="file" multiple style="display:none" @change="chooseFile" />
                        </div>
                      </div>
                      <div class="p-col-12">
                        <div class="p-field box_group_item" v-if="files && files.length">
                          <div class="p-field box-list-img">
                            <CoolLightBox
                                :items="files"
                                :index="indexUpload"
                                :fullScreen="true"
                                @close="indexUpload = null">
                            </CoolLightBox>
                            <div class="images-wrapper p-grid">
                              <div class="p-col-3 item-img"   :key="indexImg" v-for="(itemImg, indexImg) in files">
                                <div class="item" >
                                  <div class="image" style="width: 100px;height: 150px;position: relative;"  >
                                    <div v-if="disable_all == false" class="remove-icon" @click="removeImg(indexImg)"> <span class="pi pi-times" ></span></div>
                                    <img @click="indexUpload = indexImg" style="width: 100px;height: 150px" :src="itemImg.src">
                                  </div>
                                  <!--<img :src="itemImg.src" style="width: 50px;height: 50px">-->
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </TabPanel>
            <TabPanel :key="'1'"   header="Thông tin sản phẩm" >
              <div class="p-fluid p-formgrid p-grid">
                <div class="p-col-12" >
                  <div class="p-grid">
                    <div class="p-field p-col-12 p-md-6"  >
                      <div class="p-col-12">
                        <div class="title_group">TÌNH TRẠNG SẢN PHẨM</div>
                      </div>
                      <div class="p-col-12">
                        <label class="style_lable">Mô tả tình trạng của sản phẩm</label>
                        <Textarea maxlength="5000" :disabled="true" rows="5" v-model="objectData.desc_status_product" :autoResize="true"/>
                      </div>
                      <div class="p-col-12">
                        <label class="style_lable">Hình ảnh tình trạng của sản phẩm</label>
                        <div class="p-field box_group_item" v-if="objectData.list_img_status_product && objectData.list_img_status_product.length">
                          <div class="p-field "><!--box-list-img-->
                            <CoolLightBox
                                :items="objectData.list_img_status_product"
                                :index="indexImgStats"
                                :fullScreen="true"
                                srcName="url"
                                @close="indexImgStats = null">
                            </CoolLightBox>
                            <div class="images-wrapper p-grid">
                              <div class="p-col-4 p-md-4 p-lg-4 item-img"   :key="indexImgStatus" v-for="(itemImgStatus, indexImgStatus) in objectData.list_img_status_product">
                                <div class="item" >
                                  <div class="image"  @click="indexImgStats = indexImgStatus">
                                    <img style="width: 150px;height: 150px" :src="itemImgStatus.url">
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="p-field p-col-12 p-md-6" >
                      <InfoSerial :objectPopup="objectDataSerialData" ></InfoSerial>
                    </div>
                  </div>
                </div>
              </div>
            </TabPanel>
            <TabPanel :key="'1'"   header="Lịch sử cập nhật" >
              <div class="p-field p-col-12 p-md-6" >
                <div class="title_group">LỊCH SỬ THỰC HIỆN DỊCH VỤ</div>
              </div>
              <div class="table-subtable">
                <BaseCommon v-if="object_history_product.dataModel"
                            :key="object_history_product.componentKey"
                            :listData="object_history_product.listData"
                            :model="object_history_product.dataModel"
                            :filterDefault="object_history_product.filters"
                ></BaseCommon><!-- v-on:action-click="onActionClicked"
                            :actions="getRowActions()" -->
              </div>
            </TabPanel>
          </TabView>


        </div>
      </div>
    </div>
    <Dialog
        class="dialog-comfirm-common"
        :visible.sync="showConfirmDialogRestore"
        :contentStyle="{overflow: 'visible'}"
        :modal="true"
        :closable="true"
        @hide="hide_popup_restore"
    >
        <div class="box_body_popup">
          <p class="p_title_1">Sản phẩm đã hoàn thành sữa chữa sẽ được khôi phục thời hạn bảo hành ngay sau khi xác nhận đồng ý</p>
          <p class="p_title_2">(việc khôi phục không thể hoàn tác)</p>
          <div class="box_btn">
            <Button
                @click="saveData(false,true)"
                class="btn-custom"
                :label="'Khôi phục ngay'"
                type="button"
            > </Button><!--@click="saveData(true)"-->
          </div>
        </div>

      <template #header>
        <div>
          <span class="title-confirm" >Xác nhận</span>
          <!--<span class="description-confirm">asdasdas</span>-->
        </div>
      </template>
      <!--<template
          #footer
      >
        <div class="box-comfirm-button">
          <div class="btn-confirm-yes" ><span>Đồng ý</span></div>
          <div class="btn-confirm-no" ><span>Không</span></div>
        </div>
      </template>-->
    </Dialog>
  </div>
</template>

<script>
//import ServiceSarranty from './table_service_warranty'
import DataServices from '@/core/DataServices'
//import Api from '@/services'
//import moment from "moment";
//import moment from "moment";
import InfoSerial from './info_serial';
import BaseCommon from '../common';
import {constants} from "@/services/constants";
export default {
  components: {
    //ServiceSarranty
    InfoSerial,
    BaseCommon
  },
  data() {
    return {
      indexImgStats: null,
      indexUpload: null,
      listData: [],
      dataModel: null,
      componentKey: 0,
      service_pack_key: 0,
      retail_supplies_key: 0,
      modelName: 'warranty_repair_product_serial_number',
      validationErrors: {},
      list_type_failure_cause:[],
      list_type_service:[],
      list_maintenance_sessions:[],
      list_technical_user:[],//Danh sách kỹ thuật viên
      objectData:{
        check_type_service:null,
        obj_maintenance_period_change:null,
        check_maintenance_period:null,
        check_maintenance_period_old:null,
        check_presently_damaged:'',
        check_proposed_solutions:'',
        check_staff_comments:'',
        check_type_failure_cause_id:null,
        check_result:null,
        check_result_old:null,
        check_reason_not_repairing:'',
        check_reason_cancel_product:'',
        check_content_ask_customer:'',
        check_is_customer_reply:null,
        check_technical_user_id:null,
        check_cause_damage:'',
        list_img_status_product:[],
        desc_status_product:'',
        process_status:null,
        serial_number_id:0,
        product_id: null,//id của sản phẩm
        request_return_product_id:null
      },
      object_service_park:{
        list_product_service_park_init_id: [],//danh sách id lúc đầu để so sánh để xóa
        list_product_service_park: [],
        list_data: [],
        list_service_park: [],
        list_retail_supplies: [],
        selected_retail_supplies: null,
        selected_service_park: null,
        service_unit_map_data: null,
        scrollHeight: '', // chiều cao của trang danh sách
        service_total_price_service:0,
        service_total_discount:0,
        service_total_money_discount:0,
        service_tax:0,
        service_money_tax:0,
        service_total_price_payment:0,
        headerClass:'style_header',
        footerClass:'style_footer',
      },
      objectDataSerialData: {},
      warranty_repair_id:null,
      files:[],
      submitForm: false,
      disable_all: false,
      object_history_product:{
        filters: {},
        listData: [],
        dataModel: null,
        componentKey: 0
      },
      showConfirmDialogRestore:false,
      icon_check: window.origin + '/assets/images/check.png',
      check_technical_user_id_ran:0
    }
  },
  async mounted () {
    // if (this.checkVisible('add') || this.checkVisible('edit')) {
     // await this.categories();
     // await this.getSettings();
      //this.dataModel = DataServices.getModel(this.modelName);
      if (this.$route.params.id !== undefined && !isNaN(this.$route.params.id)) {
        this.titleModel = 'Chỉnh sửa model sản phẩm';
       // await this.getData(Number(this.$route.params.id));

      }
      this.initData();
    // } else {
    //   this.$store.commit('setDataLoading', {content: 'Đang tải file', icon: true});
    //   this.$store.commit('setLoading', true);
    //   this.$router.go(-1);
    // }
  },
  methods: {
     style_lable(item_data) {
       //console.log("item_data:",item_data)
       var css_text = `width: calc(100% - 100px);float: left;font-weight: 700; font-style: normal; color: #000000;`;
      if (item_data.is_parent==false && item_data.service_pack_id==-1){
         css_text=``;
       }
       return css_text
    },
    async initData() {
      this.check_technical_user_id_ran++;
      var vm = this;
      var vm_1 = this;
      var wr_product_serial_number_id = 0;
      if (this.$route.params.id !== undefined && !isNaN(this.$route.params.id)) {
        wr_product_serial_number_id = this.$route.params.id;
        var whereObject = {
          id: {'_eq': wr_product_serial_number_id}
        }
        DataServices.getObjectData('warranty_repair_product_serial_number', whereObject, {id: 'desc'}).then(async (resObj) => {
          if (resObj) {
            var serial_number_id = resObj.serial_number_id;
            //load data
            vm.objectData.request_return_product_id = (!vm.$myConstants.isEmpty(resObj.request_return_product_id)) ? resObj.request_return_product_id:null;
            vm.objectData.check_type_service = (!vm.$myConstants.isEmpty(resObj.type_service)) ? resObj.type_service:null;
            vm.objectData.check_maintenance_period = (!vm.$myConstants.isEmpty(resObj.check_maintenance_period)) ? resObj.check_maintenance_period:null;
            vm.objectData.check_maintenance_period_old = (!vm.$myConstants.isEmpty(resObj.check_maintenance_period)) ? resObj.check_maintenance_period:null;
            vm.objectData.check_presently_damaged = (!vm.$myConstants.isEmpty(resObj.check_presently_damaged)) ? resObj.check_presently_damaged:'';
            vm.objectData.check_proposed_solutions = (!vm.$myConstants.isEmpty(resObj.check_proposed_solutions)) ? resObj.check_proposed_solutions:'';
            vm.objectData.check_staff_comments = (!vm.$myConstants.isEmpty(resObj.check_staff_comments)) ? resObj.check_staff_comments:'';
            vm.objectData.check_type_failure_cause_id = (!vm.$myConstants.isEmpty(resObj.check_type_failure_cause_id)) ? resObj.check_type_failure_cause_id:null;
            vm.objectData.check_result = (!vm.$myConstants.isEmpty(resObj.check_result)) ? resObj.check_result.toString():null;
            vm.objectData.check_result_old = (!vm.$myConstants.isEmpty(resObj.check_result)) ? resObj.check_result.toString():null;
            vm.objectData.check_reason_not_repairing = (!vm.$myConstants.isEmpty(resObj.check_reason_not_repairing)) ? resObj.check_reason_not_repairing:'';
            vm.objectData.check_reason_cancel_product = (!vm.$myConstants.isEmpty(resObj.check_reason_cancel_product)) ? resObj.check_reason_cancel_product:'';
            vm.objectData.check_content_ask_customer = (!vm.$myConstants.isEmpty(resObj.check_content_ask_customer)) ? resObj.check_content_ask_customer:'';
            vm.objectData.check_is_customer_reply = (!vm.$myConstants.isEmpty(resObj.check_is_customer_reply)) ? resObj.check_is_customer_reply.toString():null;
            vm.objectData.check_technical_user_id = (!vm.$myConstants.isEmpty(resObj.check_technical_user_id)) ? resObj.check_technical_user_id:null;
            vm.objectData.check_cause_damage = (!vm.$myConstants.isEmpty(resObj.check_cause_damage)) ? resObj.check_cause_damage:'';
            vm.objectData.process_status  = (!vm.$myConstants.isEmpty(resObj.process_status )) ? resObj.process_status :null;
            vm.objectData.serial_number_id  = (!vm.$myConstants.isEmpty(resObj.serial_number_id )) ? resObj.serial_number_id :0;
            vm.objectData.desc_status_product  = (!vm.$myConstants.isEmpty(resObj.desc_status_product )) ? resObj.desc_status_product :'';
            if (resObj.process_status != 0){
              vm.disable_all = true;
            }
            var check_list_img_records_confirm = [];
            if ((!vm.$myConstants.isEmpty(resObj.check_list_img_records_confirm))){
              var img_records_confirm = JSON.parse(resObj.check_list_img_records_confirm);
              for (var h=0;h<img_records_confirm.length;h++){
                var itemImage = img_records_confirm[h];
                itemImage.old = true;
                itemImage.src = img_records_confirm[h].url;
                check_list_img_records_confirm.push(itemImage);
              }
            }
            vm.files = check_list_img_records_confirm;

            /**/
            vm.warranty_repair_id = resObj.warranty_repair_id;
            vm.objectData.list_img_status_product = (!vm.$myConstants.isEmpty(resObj.list_img_status_product)) ? JSON.parse(resObj.list_img_status_product) : [];
            if (!vm.$myConstants.isEmpty(resObj.product_serial_number)) {
              if (!vm.$myConstants.isEmpty(resObj.product_serial_number.serial_number)) {
                var info_customer = (!vm.$myConstants.isEmpty(resObj.info_customer_product_serial_number)) ? JSON.parse(resObj.info_customer_product_serial_number) : null;
                vm.load_serial_service(resObj.product_serial_number.serial_number, info_customer);
                vm.objectData.product_id  = (!vm.$myConstants.isEmpty(resObj.product_serial_number.product_id)) ? resObj.product_serial_number.product_id :0;
              }
            }
            //Lấy danh sách nhận viên kỹ thuật thuộc đơn vị
            if (!vm.$myConstants.isEmpty(resObj.obj_warranty_repair)) {
              if (!vm.$myConstants.isEmpty(resObj.obj_warranty_repair.obj_modifier)) {
                if (!vm.$myConstants.isEmpty(resObj.obj_warranty_repair.obj_modifier.organization_account)) {
                  var organization_id_modifier = resObj.obj_warranty_repair.obj_modifier.organization_account.organization_id;
                  vm.$coreService.get_user_by_organizatio_id(organization_id_modifier,null).then(async (data_user) => {
                    vm.list_technical_user = data_user;
                  }).catch(async () => {
                    vm.list_technical_user = [];
                  });
                }
              }
            }
            await vm.$myConstants.sleep(200);//delay 0.5 giây
            //Load danh sách gói dịch vụ và vật tư
            var list_service_park_id = [];
            var list_retail_supplies_id = [];
            if (resObj.check_result == 0 || (resObj.check_result == 2)){
              var resDataProductService = await vm.getListProductService(resObj.id);
              list_service_park_id = resDataProductService.list_service_park_id;
              list_retail_supplies_id = resDataProductService.list_retail_supplies_id;
              vm_1.object_service_park.service_total_price_service = (!vm.$myConstants.isEmpty(resObj.service_total_price_service)) ? parseFloat(resObj.service_total_price_service):0;
              vm_1.object_service_park.service_total_discount = (!vm.$myConstants.isEmpty(resObj.service_total_discount)) ? parseFloat(resObj.service_total_discount):0;
              vm_1.object_service_park.service_total_money_discount = (!vm.$myConstants.isEmpty(resObj.service_total_money_discount)) ? parseFloat(resObj.service_total_money_discount):0;
              vm_1.object_service_park.service_tax = (!vm.$myConstants.isEmpty(resObj.service_tax)) ? parseFloat(resObj.service_tax):0;
              vm_1.object_service_park.service_money_tax = (!vm.$myConstants.isEmpty(resObj.service_money_tax)) ? parseFloat(resObj.service_money_tax):0;
              vm_1.object_service_park.service_total_price_payment = (!vm.$myConstants.isEmpty(resObj.service_total_price_payment)) ? parseFloat(resObj.service_total_price_payment):0;
            }
            //load danh sách gói dịch vụ lõi trừ những id đã có
            vm.get_list_service_park({id: {'_nin': list_service_park_id} },vm.objectData.product_id);
            vm.get_list_retail_supplies({id: {'_nin': list_retail_supplies_id} });//list_retail_supplies_id
            //load đợt bảo trì
            var list_maintence = await vm.load_maintence(serial_number_id,resObj.process_status);
            var is_exist_maintence = (list_maintence.length > 0) ? true:false;
            this.load_type_service(is_exist_maintence);
          }
        }).catch(async (err) => {
          console.log("errerrerr:",err)
          vm.$toast.add({
            severity: 'error',
            summary: 'Thông báo',
            detail: 'Hệ thống đã gặp sự cố !Xin vui lòng thử lại.',
            life: 3000
          });
        });
      }/*else {
        //load danh sách gói dịch vụ
        this.get_list_service_park({status: {'_in': [1]}});
      }*/
      this.load_type_failure_cause();
      await this.service_unit_map();
      //Load lịch sử thay đổi sản phẩm
      this.load_history_product(this.$route.params.id);

    },
    async changeResult() {
      var vm = this;
      var check_maintenance_period = vm.objectData.check_maintenance_period;
      if (vm.objectData.check_type_service == this.$dataCommon.WARRANTY_REPAIR.TYPE_SERVICE.MAINTENANCE && !vm.$myConstants.isEmpty(check_maintenance_period)){
        if (vm.$myConstants.isEmpty(this.objectData.check_result_old)){
          //Nếu lần đầu chưa chọn thì mới load dịch vụ có bảo trì
          vm.changeMaintenceChangeServicePark(check_maintenance_period);
        }
      }
      this.objectData.check_result_old = this.objectData.check_result;
    },
    async changeMaintence(){
      var vm = this;
      var check_maintenance_period = vm.objectData.check_maintenance_period;
      if ((vm.objectData.check_result == '0' || (vm.objectData.check_result == '2'  && vm.objectData.check_is_customer_reply == '1' ))){
        alert("Danh sách dịch vụ sửa chữa - bảo hành -bảo trì đã bị thay đổi. Vui lòng kiểm tra lại");
        this.object_service_park.list_product_service_park = [];
        vm.changeMaintenceChangeServicePark(check_maintenance_period);
        vm.object_service_park.service_total_price_service = 0;
        vm.object_service_park.service_total_discount = 0;
        vm.object_service_park.service_total_money_discount = 0;
        vm.object_service_park.service_tax = 0;
        vm.object_service_park.service_money_tax = 0;
        vm.object_service_park.service_total_price_payment = 0;
      }
      //lấy item bảo trì thay đổi
      for (var i=0;i<this.list_maintenance_sessions.length;i++){
        if (parseFloat(this.list_maintenance_sessions[i].id) == parseFloat(check_maintenance_period)){
          vm.objectData.obj_maintenance_period_change = this.list_maintenance_sessions[i];
          break;
        }
      }
    },
    async changeMaintenceChangeServicePark(check_maintenance_period){
      var vm = this;
      //Lấy đợt bảo trì
      var list_maintenance = vm.list_maintenance_sessions;
      var item_maintence = null;
      for (var i=0;i<list_maintenance.length;i++){
        if (parseFloat(list_maintenance[i].id) == parseFloat(check_maintenance_period)){
          item_maintence = list_maintenance[i];
          break;
        }
      }
      if (!vm.$myConstants.isEmpty(item_maintence)){
        var list_service_pack_id = (!vm.$myConstants.isEmpty(item_maintence.list_service_pack_id)) ? JSON.parse(item_maintence.list_service_pack_id):[];
        //kiểm tra gói dịch vụ có còn tồn tại ko
        var list_service_pack =await vm.get_list_service_park({ id: {'_in': list_service_pack_id} },vm.objectData.product_id,true);
        //console.log("list_service_packlist_service_pack:",list_service_pack)
        for (var s=0;s<list_service_pack.length;s++){
          await this.process_add_service_park(list_service_pack[s].id);
        }
      }
    },
    async load_maintence(serial_number_id,process_status) {
      var process_status_display = [];
      if (process_status == 0){
        process_status_display = [this.$dataCommon.MAINTENANCE.PROCESS_STATUS.PLAN,this.$dataCommon.MAINTENANCE.PROCESS_STATUS.MAINTENANCE_NEEDED,this.$dataCommon.MAINTENANCE.PROCESS_STATUS.PROCESSING];
      }else {
        //nếu bi disble thì lấy hết đợt
        for (const [key, value] of Object.entries(this.$dataCommon.MAINTENANCE.PROCESS_STATUS)) {
          process_status_display.push(value);
          if (key);
        }
      }
      var list = await this.$coreService.get_maintence_by_serial_number_id(serial_number_id,process_status_display);
      if (list !== undefined && list !== null && Object.keys(list).length) {
        for (let index = 0; index < list.length; index++) {
          list[index].lable = "Đợt "+list[index].parts_number;
        }
        this.list_maintenance_sessions = list;
      }
      return list;
    },
    dang_phat_trien(){
      if (this.objectData.check_type_service == 'T07'){
        alert("Chứ năng này đang phát triển");
        this.objectData.check_type_service = null;
      }
    },
    backList() {
      this.$router.go(-1);
      // this.$router.push({path: '/admin/service-park'});
      // window.location.href = window.origin +'/admin/warranty-repair/function/'+this.warranty_repair_id;
    },
    async process_restore_product_serial(){
      var vm = this;
      //this.$store.commit('setDataLoading', {content: 'Đang lưu dữ liệu', icon: true});
     // this.$store.commit('setLoading', true);
      var serial_number_id = vm.objectData.serial_number_id;
      var params_upd_product_serial_number_info = {
        warranty_status: 5,
      }
      var params_upd_product_serial_number = {
        warranty_status: 5,
      }
      var params_upd_request_activation_product_serial = {
        warranty_status: 5,
      }
      //Lấy kích hoạt bảo hành cuối cùng
      var where = {
        serial_number_id: {_eq: serial_number_id}
      };
      var objRequestActivation = await DataServices.getObjectData('request_activation_product_serial',where,{id: 'desc'});
      var request_activation_product_serial_id = (!this.$myConstants.isEmpty(objRequestActivation.id)) ? objRequestActivation.id:'';
      /**
       * Ngân note FS
       * Cập nhật trạng thái bảo hành cho sản phẩm đó  từ “Đã kích hoạt” thành “Tắt kích hoạt”, (warranty_status = 5 ở cả 2 bảng dữ liệu core_product_serial_number và core_product_serial_number_info)
       * */
      var queryUpdateStatus = `
        mutation update_core_product_serial_number_info_multil($core_product_serial_number_info_object: core_product_serial_number_info_set_input,$core_product_serial_number_object: core_product_serial_number_set_input,$core_request_activation_product_serial_object: core_request_activation_product_serial_set_input) {
          update_core_product_serial_number_info(where: { serial_number_id: {_eq: "${serial_number_id}"}}, _set: $core_product_serial_number_info_object) {
            affected_rows
            returning {
              serial_number_id
            }
          }
          update_core_product_serial_number(where: { id: {_eq: "${serial_number_id}"}}, _set: $core_product_serial_number_object) {
            affected_rows
            returning {
              id
            }
          }
          update_core_request_activation_product_serial(where: { id: {_eq: "${request_activation_product_serial_id}"}}, _set: $core_request_activation_product_serial_object) {
            affected_rows
            returning {
              id
            }
          }
        }
          `;
      var variablesUpdateStatus = {
        "variables": JSON.stringify({
          core_product_serial_number_info_object: params_upd_product_serial_number_info,
          core_product_serial_number_object: params_upd_product_serial_number,
          core_request_activation_product_serial_object: params_upd_request_activation_product_serial,
        })
      };
      DataServices.executeQuery('product_serial_number', queryUpdateStatus, variablesUpdateStatus).then(async () => {
        //ghi log thay đổi
        /*var list_wr_product_serial_number_id = [];
        list_wr_product_serial_number_id.push(vm.$route.params.id);
        vm.$coreService.updateHistoryWarrantyRepairProductSn('Cập nhật thông tin', list_wr_product_serial_number_id, 5, vm.$store.getters.fullname.id);*/
        //vm.$store.commit('setLoading', false);
        //vm.$router.push({path: '/admin/warranty-repair/function/'+vm.warranty_repair_id});
      }).catch(async () => {});
    },
    hide_popup_restore(){
      /*var vm = this;
      vm.$router.push({path: '/admin/warranty-repair/function/'+vm.warranty_repair_id});*/
    },
    async load_history_product(wr_product_serial_number_id) {
      var variables = {
        where_key: {
          //type: {'_eq': 0 },
          status: {'_in': [1] },
          warranty_repair_product_serial_number_id: {_eq: wr_product_serial_number_id}
        },
        orderBy: {
          id: 'desc',
        }
      }
      var data = await DataServices.getList('warranty_repair_product_sn_history_update', {"variables": JSON.stringify(variables)});
      var list = data[Object.keys(data)];
      this.object_history_product.dataModel = DataServices.getModel('warranty_repair_product_sn_history_update');
      this.object_history_product.dataModel.processData(list);
      this.object_history_product.listData = list;
      this.object_history_product.componentKey++;
    },
    async load_serial_service(serial_number, info_customer) {
      var vm = this;
      var checkSerialNumber = await vm.$coreService.getSerialWarrantyActivationBySerial(serial_number);
      if (checkSerialNumber) {
        var param_convert = {
          mode: 'add',
          type_service: null,
          maintenance_period: null,
          desc_status_product: '',
          list_img_status_product: [],
          objectDataSerial: checkSerialNumber
        };
        //var data_convert = this.convertObjectDataSerial(param_convert);
        var data_convert = vm.$coreService.convertObjectDataSerial(param_convert);
        if (!this.$myConstants.isEmpty(info_customer)) {
          //Gán customer đã lưu vào
          data_convert.object_info_product.full_name = (!this.$myConstants.isEmpty(info_customer.full_name)) ? info_customer.full_name : '';
          data_convert.object_info_product.phone_number = (!this.$myConstants.isEmpty(info_customer.phone_number)) ? info_customer.phone_number.replace('+84', '0') : '';
          if (info_customer.customer_type == 1) data_convert.object_info_product.group_customer = 'Cá nhân';
          else if (info_customer.customer_type == 2) data_convert.object_info_product.group_customer = 'Doanh nghiệp';
        }
        vm.objectDataSerialData = data_convert;
      }
    },
    async load_type_service(is_exist_maintence) {
      var list = await this.$coreService.get_warranty_repair_type_service_all();
      if (list !== undefined && list !== null && Object.keys(list).length) {
        for (let index = 0; index < list.length; index++) {
          const item = list[index];
          if (item.code == this.$dataCommon.WARRANTY_REPAIR.TYPE_SERVICE.MAINTENANCE) {
            if (is_exist_maintence == true){
              this.list_type_service.push({label: item.name, value: item.code, item: item});
            }
          }else if (item.code == this.$dataCommon.WARRANTY_REPAIR.TYPE_SERVICE.REPAIR_APPRAISAL){
            if (this.objectData.check_type_service == this.$dataCommon.WARRANTY_REPAIR.TYPE_SERVICE.REPAIR_APPRAISAL){
              //Nếu loại dịch vụ hiện tại thì mới show Sữa chữa sản phẩm thẩm định ra
              this.list_type_service.push({label: item.name, value: item.code, item: item});
            }
          }
          else {
            this.list_type_service.push({label: item.name, value: item.code, item: item});
          }
        }
      }
    },
    async load_type_failure_cause() {
      var list = await this.$coreService.get_type_failure_cause_all();
      this.list_type_failure_cause = list;
    },
    noop () {
      //Chặn redirect submit form
      return false;
    },
    onlyUnique(value, index, self) {
      return self.indexOf(value) === index;
    },
    change_is_free(data,column) {
      var obj_data = data.data;
      var service_pack_id = obj_data.service_pack_id;
      var list_product_service_park = this.object_service_park.list_product_service_park;
      if (obj_data.is_parent == true){
        var is_free = obj_data.is_free;
          //active hết con
        for (var i=0;i<list_product_service_park.length;i++){
          var item_data = list_product_service_park[i];
          if (parseFloat(item_data.service_pack_id) == parseFloat(service_pack_id) && item_data.is_parent == false){
            this.object_service_park.list_product_service_park[i].is_free = is_free;//is_free của con đi theo cha
          }
        }
      }else {
        //nếu bỏ active con thì bỏ active cha
        if (obj_data.is_free == false){
          for (var j=0;j<list_product_service_park.length;j++){
            var item_data_ = list_product_service_park[j];
            if (parseFloat(item_data_.service_pack_id) == parseFloat(service_pack_id) && item_data_.is_parent == true){
              this.object_service_park.list_product_service_park[j].is_free = false;
              break;
            }
          }
        }
      }
      this.calc_all_price();
      console.log("dadadaddd",column);
    },
    change_data_footer(column){
      let is_not_load_money_discount = false;
      switch(column) {
        case 'service_total_discount':
          is_not_load_money_discount = true;
          this.object_service_park.service_total_money_discount = Math.floor((this.object_service_park.service_total_price_service)*(this.object_service_park.service_total_discount/100));
          break;
        case 'service_total_money_discount':
          if (parseFloat(this.object_service_park.service_total_price_service) < this.object_service_park.service_total_money_discount){
            this.$toast.add({
              severity: 'error',
              summary: 'Thông báo',
              detail: 'Tiền giảm giá không thể lớn hơn tổng cộng.Vui lòng kiểm tra lại',
              life: 3000
            });
            this.object_service_park.service_total_money_discount = Math.floor(this.object_service_park.service_total_price_service);
            //return false;
          }

          is_not_load_money_discount = true;
          var service_total_discount = 0;
          if (this.object_service_park.service_total_price_service != 0){
            service_total_discount = (this.object_service_park.service_total_money_discount*100)/(this.object_service_park.service_total_price_service);
          }
         // this.object_service_park.service_total_discount = parseFloat(service_total_discount.toFixed(1));
          console.log("service_total_discount",service_total_discount)
          console.log("this.object_service_park.service_total_discount",this.object_service_park.service_total_price_service)
          break;
        case 'service_tax':
          //this.object_service_park.service_money_tax = (this.object_service_park.service_total_price_service - this.object_service_park.service_total_money_discount)*(this.object_service_park.service_tax/100);
          break;
        case 'service_money_tax':
         // this.list_product_service_park[index].discount = (this.object_service_park.list_product_service_park[index].money_discount * 100) / (this.object_service_park.list_product_service_park[index].unit_price * this.object_service_park.list_product_service_park[index].number);

          break;
        default:
          // code block
      }
      this.calc_all_price(is_not_load_money_discount);
      }
    ,
    change_data_table(data,column) {
      var index = data.index;
      //var obj_data = data.data;
      /*  number:0,
            discount:0,
            money_discount:0,
            total_price:0,*/
      switch(column) {
        case 'number':
          //thay đổi số lượng thì lấy phần trăm tính tiền giảm giá => Ngân nói
          var money_discount_n = (this.object_service_park.list_product_service_park[index].unit_price*this.object_service_park.list_product_service_park[index].number)*(this.object_service_park.list_product_service_park[index].discount/100);
          this.object_service_park.list_product_service_park[index].money_discount = Math.floor(money_discount_n)
          break;
        case 'discount':
          var money_discount =(this.object_service_park.list_product_service_park[index].unit_price*this.object_service_park.list_product_service_park[index].number)*(this.object_service_park.list_product_service_park[index].discount/100);
          this.object_service_park.list_product_service_park[index].money_discount = Math.floor(money_discount);
          break;
        case 'money_discount':
          var total_price = (this.object_service_park.list_product_service_park[index].unit_price*this.object_service_park.list_product_service_park[index].number);
          //console.log(this.object_service_park.list_product_service_park[index].money_discount);
          if (parseFloat(total_price) < this.object_service_park.list_product_service_park[index].money_discount){
            this.$toast.add({
              severity: 'error',
              summary: 'Thông báo',
              detail: 'Tiền giảm giá không thể lớn hơn tổng cộng.Vui lòng kiểm tra lại',
              life: 3000
            });
            this.object_service_park.list_product_service_park[index].money_discount = Math.floor(total_price);
            //return false;
          }
          var discount = 0;
          if ((this.object_service_park.list_product_service_park[index].unit_price*this.object_service_park.list_product_service_park[index].number) != 0) {//check trường hợp ko thể chia cho 0 nên bị NaN
            discount = (this.object_service_park.list_product_service_park[index].money_discount * 100) / (this.object_service_park.list_product_service_park[index].unit_price * this.object_service_park.list_product_service_park[index].number)
          }
          this.object_service_park.list_product_service_park[index].discount = parseFloat(discount.toFixed(1));
          break;
        default:
          // code block
      }
      this.calc_all_price();
    },
    calc_all_price(is_not_load_money_discount=false){
      var list_product_service_park = this.object_service_park.list_product_service_park;
      var list_index_parent = {};
      var list_total_price_parent = {};
      var service_total_price_service = 0;
      for (var i=0;i<list_product_service_park.length;i++){
        var item_data = list_product_service_park[i];
        var service_pack_id = item_data.service_pack_id;
        if (item_data.is_parent == false) {
          if (item_data.is_free == true) {
            this.object_service_park.list_product_service_park[i].total_price = 0;
          } else {
            //Đơn giá * Số lượng - Tiền giảm giá
            this.object_service_park.list_product_service_park[i].total_price = Math.floor((item_data.unit_price*item_data.number) - item_data.money_discount);
          }
          service_total_price_service += this.object_service_park.list_product_service_park[i].total_price;
        }
        if (item_data.is_parent == true){
          list_index_parent[service_pack_id] = i;
        }else {
          //lưu tổng tiền parent
          if (!this.$myConstants.isEmpty(list_total_price_parent[service_pack_id])){
            list_total_price_parent[service_pack_id] += parseFloat(item_data.total_price);
          }else {
            list_total_price_parent[service_pack_id] = parseFloat(item_data.total_price);
          }

        }
      }
      for (const [service_pack_id_key, value_index] of Object.entries(list_index_parent)) {
        this.object_service_park.list_product_service_park[value_index].total_price = Math.floor(list_total_price_parent[service_pack_id_key]);
      }
      this.object_service_park.service_total_price_service = Math.floor(service_total_price_service);
      if (!is_not_load_money_discount){
        this.object_service_park.service_total_money_discount = Math.floor( (this.object_service_park.service_total_price_service)*(this.object_service_park.service_total_discount/100) );
      }
      this.object_service_park.service_money_tax =Math.floor( (this.object_service_park.service_total_price_service - this.object_service_park.service_total_money_discount)*(this.object_service_park.service_tax/100) );
      this.object_service_park.service_total_price_payment =Math.floor( this.object_service_park.service_total_price_service - this.object_service_park.service_total_money_discount + this.object_service_park.service_money_tax );
    },
    delete_service_park(event, data){
      event.preventDefault();
      var vm = this;
      //var index = data.index;
      var obj_data = data.data;
      var service_pack_id = obj_data.service_pack_id;
      console.log("service_pack_id:",service_pack_id)
      var is_parent = obj_data.is_parent;
    //  var service_pack_service_supplies_id = obj_data.service_pack_service_supplies_id;
      var service_supplies_id = obj_data.service_supplies_id;

      var count_item_retail= 0;
      if (parseFloat(service_pack_id) ==-1 ){
        for (var a = 0; a < this.object_service_park.list_product_service_park.length; a++) {
          var service_pack_id_check_tmp = this.object_service_park.list_product_service_park[a].service_pack_id;
          if (service_pack_id_check_tmp == -1) {
            count_item_retail++;
          }
        }
      }

      var removeIndex = [];
      var list_id = [];
      var list_supplies_id = [];

      for (var g = 0; g < this.object_service_park.list_product_service_park.length; g++) {
        var service_pack_id_check = this.object_service_park.list_product_service_park[g].service_pack_id;
        var service_supplies_id_check = this.object_service_park.list_product_service_park[g].service_supplies_id;
        if (parseFloat(service_pack_id) ==-1){
          if (parseFloat(service_pack_id_check) == -1) {
            if (is_parent) {
              removeIndex.push(g);
            } else {
              console.log("service_pack_service_supplies_id:",service_supplies_id)
              console.log("service_pack_service_supplies_id_check:",service_supplies_id_check)
              console.log("kkkkkkkkkkkkkkkkkkk:",count_item_retail)
              if (parseFloat(service_supplies_id) == parseFloat(service_supplies_id_check) || count_item_retail<3){
                removeIndex.push(g);
                //console.log("ggggggggdddddddd:",g)
               // list_supplies_id.push(service_supplies_id_check);
              }else {
                list_supplies_id.push(service_supplies_id_check);
              }
            }
          }
        }else {
          if (parseFloat(this.object_service_park.list_product_service_park[g].service_pack_id) == parseFloat(service_pack_id)) {
            removeIndex.push(g);
          } else {
            if (!list_id.includes(parseFloat(this.object_service_park.list_product_service_park[g].service_pack_id))) {
              //ko tồn tại thì push vào tránh trùng lặp
              list_id.push(parseFloat(this.object_service_park.list_product_service_park[g].service_pack_id));
            }
          }
        }
      }
      console.log("removeIndexremoveIndex:",removeIndex)
      //nếu trường hợp xóa vật tư lẻ còn có 1 cái thì xóa lun cha
      // removeIndex = removeIndex.filter(this.onlyUnique);
      for (var i = removeIndex.length -1; i >= 0; i--){//xóa ngược để ko thay đổi index của array
        this.object_service_park.list_product_service_park.splice(removeIndex[i], 1);
      }
      console.log("service_pack_idww:",service_pack_id)
      if (parseFloat(service_pack_id) ==-1){
        console.log("list_supplies_idlist_supplies_id:",list_supplies_id)
        var where_key = {};
        if (list_supplies_id.length > 0){
          where_key.id = {'_nin': list_supplies_id};
        }
        this.get_list_retail_supplies(where_key);
      }else{
        this.get_list_service_park({id: {'_nin': list_id} },vm.objectData.product_id);
      }
      this.calc_all_price();//tính lại
    },
    async add_retail_supplies() {
      //var vm =this;
      if (!this.object_service_park.selected_retail_supplies) {
        this.$toast.add({
          severity: 'error',
          summary: 'Thông báo',
          detail: 'Vui lòng chọn vật tư lẻ.',
          life: 3000
        });
        return false;
      }
      /*var service_pack_id = this.object_service_park.selected_service_park.id;
      //check server đã tồn tại
      for (var j=0;j<this.object_service_park.list_product_service_park.length;j++){
        if (parseFloat(this.object_service_park.list_product_service_park[j].service_pack_id) == service_pack_id){
          this.$toast.add({
            severity: 'error',
            summary: 'Thông báo',
            detail: 'Gói dịch vụ đã tồn tại.',
            life: 3000
          });
          return false;
        }
      }*/
      var obj_sv_supplies = this.object_service_park.selected_retail_supplies;
      var id_service_supplies = (!this.$myConstants.isEmpty(obj_sv_supplies.id)) ? obj_sv_supplies.id:0;
      var list_data = this.object_service_park.list_product_service_park;
      //console.log("obj_sv_supplies:",obj_sv_supplies)
      for (var i=0;i<list_data.length;i++){
        console.log("list_data[i]:",list_data[i])
        var   service_supplies_id_check  =  (!this.$myConstants.isEmpty(list_data[i].service_supplies_id)) ? list_data[i].service_supplies_id:0;
        if (parseFloat(service_supplies_id_check) > 0 && parseFloat(service_supplies_id_check)== parseFloat(id_service_supplies)){
         // console.log("service_pack_service_supplies_id:",service_pack_service_supplies_id)
          //console.log("id_service_supplies:",id_service_supplies)
          this.$toast.add({
            severity: 'error',
            summary: 'Thông báo',
            detail: 'Vật tư đã được chọn.',
            life: 3000
          });
          return false;
        }
      }
      console.log("obj_sv_supplies:",obj_sv_supplies)
      this.retail_supplies_key++;
      this.process_add_retail_supplies(obj_sv_supplies);
    },
    async process_add_retail_supplies(obj_sv_supplies) {
      //console.log(service_pack_id)
      if (!this.$myConstants.isEmpty(obj_sv_supplies)) {
        var list_data = this.object_service_park.list_product_service_park;
        var list_service_supplies_retail = [];
        //var list_service_parent_supplies_retail = [];
        var removeIndex = [];
        var obj_parent_old = null;
        for (var i=0;i<list_data.length;i++){
          var item_data =  list_data[i];
          var is_parent = item_data.is_parent;
          var service_pack_id_check = item_data.service_pack_id;
          if (is_parent == false && service_pack_id_check ==-1){
            list_service_supplies_retail.push(item_data);
            removeIndex.push(i);
          }

          if (is_parent == true && service_pack_id_check ==-1){
            removeIndex.push(i);
            obj_parent_old = item_data;
          }
        }
        console.log("removeIndexremoveIndex:",removeIndex)
        for (var h = removeIndex.length -1; h >= 0; h--){//xóa ngược để ko thay đổi index của array
          console.log("assssssssss")
          this.object_service_park.list_product_service_park.splice(removeIndex[h], 1);
        }
        var obj_data_service_park = {
          lable:'Vật tư lẻ',
          unit_name:'',
          is_free:false,
          unit_price:'',
          unit_price_text:'',
          number:'',
          discount:'',
          money_discount:'',
          total_price:0,
          service_pack_id:-1,
          is_parent:true,
          info_data:null,
          service_pack_service_supplies_id:0,
          service_supplies_id:0,
          number_err:'',
          discount_err:'',
          money_discount_err:'',
        }
        if (!this.$myConstants.isEmpty(obj_parent_old)){
          this.object_service_park.list_product_service_park.push(obj_parent_old);//push vào cuối mảng
        }else {
          this.object_service_park.list_product_service_park.push(obj_data_service_park);//push vào cuối mảng
        }

        var obj_data_service_supplies = {
          lable:(!this.$myConstants.isEmpty( obj_sv_supplies.lable) ?  obj_sv_supplies.lable : ''),
          unit_name: (!this.$myConstants.isEmpty( obj_sv_supplies.unit) ? obj_sv_supplies.unit : ''),
          is_free: false,
          unit_price:(!this.$myConstants.isEmpty(  obj_sv_supplies.unit_price) ?  obj_sv_supplies.unit_price : 0) ,
          unit_price_text: (!this.$myConstants.isEmpty(obj_sv_supplies.unit_price)) ? this.$myConstants.numberFormat(obj_sv_supplies.unit_price, 0, '', '.') : '0',
          number: 0,
          discount: 0,
          money_discount: 0,
          total_price: 0,
          service_pack_id: -1,
          is_parent: false,
          info_data: obj_sv_supplies,
          service_pack_service_supplies_id: 0,
          service_supplies_id: obj_sv_supplies.id,
          number_err: '',
          discount_err: '',
          money_discount_err: '',
        }
        list_service_supplies_retail.unshift(obj_data_service_supplies);
        var list_id = [];
        if (list_service_supplies_retail.length>0){
          for (var t=0;t<list_service_supplies_retail.length;t++){
            list_id.push(list_service_supplies_retail[t].service_supplies_id);
            this.object_service_park.list_product_service_park.push(list_service_supplies_retail[t]);//push vào cuối mảng
          }
        }
        console.log(" this.object_service_park.list_product_service_park:", this.object_service_park.list_product_service_park)
        var where_key = {};
        if (list_id.length > 0){
          where_key.id = {'_nin': list_id};
        }
        this.object_service_park.selected_retail_supplies=null;
        this.get_list_retail_supplies(where_key);
      }
    },
    async add_service_park() {
      //var vm =this;
      if (!this.object_service_park.selected_service_park) {
        this.$toast.add({
          severity: 'error',
          summary: 'Thông báo',
          detail: 'Vui lòng chọn gói dịch vụ.',
          life: 3000
        });
        return false;
      }
      var service_pack_id = this.object_service_park.selected_service_park.id;
      //check server đã tồn tại
      for (var j=0;j<this.object_service_park.list_product_service_park.length;j++){
        if (parseFloat(this.object_service_park.list_product_service_park[j].service_pack_id) == service_pack_id){
          this.$toast.add({
            severity: 'error',
            summary: 'Thông báo',
            detail: 'Gói dịch vụ đã tồn tại.',
            life: 3000
          });
          return false;
        }
      }
      this.service_pack_key++;
      this.process_add_service_park(service_pack_id);
    },
    async process_add_service_park(service_pack_id) {
      var vm  = this;
      var list_service_supplies = await this.$coreService.get_service_supplies_by_id_service_park({service_pack_id: {_eq: service_pack_id}});
      if (list_service_supplies.length > 0){
        list_service_supplies.reverse();//đảo ngược mảng lại
        for (var i=0;i<list_service_supplies.length;i++){
          var service_unit_map = this.object_service_park.service_unit_map_data[list_service_supplies[i].obj_service_supplies.unit];
          var obj_data_service_supplies = {
            lable:list_service_supplies[i].obj_service_supplies.code+' - '+list_service_supplies[i].obj_service_supplies.name,
            unit_name:(!this.$myConstants.isEmpty(service_unit_map) ? service_unit_map:''),
            is_free:false,
            unit_price:list_service_supplies[i].obj_service_supplies.unit_price,
            unit_price_text:  (!this.$myConstants.isEmpty(list_service_supplies[i].obj_service_supplies.unit_price)) ? this.$myConstants.numberFormat(list_service_supplies[i].obj_service_supplies.unit_price, 0, '', '.') : '0',
            number:0,
            discount:0,
            money_discount:0,
            total_price:0,
            service_pack_id:service_pack_id,
            is_parent:false,
            info_data:list_service_supplies[i].obj_service_supplies,
            service_pack_service_supplies_id:list_service_supplies[i].id,
            service_supplies_id: list_service_supplies[i].obj_service_supplies.id,
            number_err:'',
            discount_err:'',
            money_discount_err:'',
          }
          this.object_service_park.list_product_service_park.unshift(obj_data_service_supplies);
        }
      }
      //Lấy server park hiện tại trên list
      var whereItemServicePark = {
        id: {_eq: service_pack_id}
      };
      var selected_service_park = await DataServices.getObjectData('service_park',whereItemServicePark,{id: 'desc'});
      var obj_data_service_park = {
        lable:selected_service_park.code+' - '+selected_service_park.name,
        unit_name:'',
        is_free:false,
        unit_price:'',
        unit_price_text:'',
        number:'',
        discount:'',
        money_discount:'',
        total_price:0,
        service_pack_id:service_pack_id,
        is_parent:true,
        info_data:selected_service_park,
        service_pack_service_supplies_id:0,
        service_supplies_id: 0,
        number_err:'',
        discount_err:'',
        money_discount_err:'',
      }
      this.object_service_park.list_product_service_park.unshift(obj_data_service_park);

      //Lấy danh sách id service park đã tồn tại
      var list_id = [];
      for (var g = 0; g < this.object_service_park.list_product_service_park.length; g++) {
        if (!list_id.includes(parseFloat(this.object_service_park.list_product_service_park[g].service_pack_id))){
          //ko tồn tại thì push vào tránh trùng lặp
          list_id.push(parseFloat(this.object_service_park.list_product_service_park[g].service_pack_id));
        }
      }
      this.object_service_park.selected_service_park = null;
      this.get_list_service_park({ id: {'_nin': list_id} },vm.objectData.product_id);
    },
    async get_list_service_park(whereAttach=null,product_id=null,is_return = false) {
      var whereDefault = {status: {'_in': [1]}};
          whereAttach._or = [];
          whereAttach._or.push({apply_all_model: {_eq: "1"}});//điều kiện tất cả các model sản phẩm
          if (!this.$myConstants.isEmpty(product_id)){
            whereAttach._or.push({arr_service_pack_product: {product_id: {_eq: product_id}, status: {_eq: "1"}}});//hoặc gói dịch vụ thuộc sp
          }
      if (whereAttach){
        for (const [key, value] of Object.entries(whereAttach)) {
          whereDefault[key] = value;
        }
      }
      var list_data = await this.$coreService.get_service_park_all(whereDefault);
      for (var i=0;i<list_data.length;i++){
        list_data[i].lable = list_data[i].code+' - '+list_data[i].name;
      }
      if (is_return == true){
        return list_data;
      }else {
        this.object_service_park.list_service_park = list_data;
      }
    },
    async get_list_retail_supplies(whereAttach=null) {
      var where_key = {
        status: {'_in': [1]},//0,
      };
      if (whereAttach){
        for (const [key, value] of Object.entries(whereAttach)) {
          where_key[key] = value;
        }
      }
      var variables = {
        where_key:where_key,
        orderBy: {
          id: 'desc',
        }
      }
      var list_data = await DataServices.getListData('service_supplies', {"variables": JSON.stringify(variables)});
      var map_check_name = {};
      for (var i=0;i<list_data.length;i++){
        var item_data = list_data[i];
        var lable_text =  item_data.code+' - '+item_data.name;
        //list_data[i].lable = lable_text;
        if (constants.isEmpty(map_check_name[lable_text])){
          map_check_name[lable_text] = 0;
        }
        map_check_name[lable_text] = map_check_name[lable_text]+1;
        var str_space = " ";
        list_data[i].lable =lable_text+str_space.repeat(parseFloat(map_check_name[lable_text]));
      }
      this.object_service_park.list_retail_supplies =list_data;
      console.log("list_service_supplies_retail:",list_data)
    },
    async service_unit_map() {
      var list_data = await this.$coreService.get_service_unit_all();
      var list_map_data = {};
      for (var i=0;i<list_data.length;i++){
        list_map_data[list_data[i].code] = list_data[i].name;
      }
      this.object_service_park.service_unit_map_data = list_map_data;
      //return list_map_data;
    },
    async update_total_cost_wr(warranty_repair_id,service_total_price_payment) {
      var vm = this;
      var whereObject = {
        id: {'_eq': warranty_repair_id}
      }
      DataServices.getObjectData('warranty_repair_detail', whereObject, {id: 'desc'}).then(async (resObj) => {
        if (resObj) {
          var total_cost_current = (!vm.$myConstants.isEmpty(resObj.total_cost)) ? parseFloat(resObj.total_cost):0;
          if (service_total_price_payment<0){
            service_total_price_payment = 0;
          }
          var params = {
            total_cost: service_total_price_payment+total_cost_current,
          }
          var queryUpdateStatus = `
        mutation update_core_warranty_repair_multil($core_warranty_repair_object: core_warranty_repair_set_input) {
          update_core_warranty_repair(where: { id: {_eq: "${warranty_repair_id}"}}, _set: $core_warranty_repair_object) {
            affected_rows
            returning {
              id
            }
          }
        }
          `;
          var variablesUpdateStatus = {
            "variables": JSON.stringify({
              core_warranty_repair_object: params,
            })
          };
          DataServices.executeQuery('warranty_repair', queryUpdateStatus, variablesUpdateStatus).then(async () => {
            //location.reload();
            //vm.$router.push({ path: vm.$router.currentRoute.path,query: { key_auto: ((new Date()).getTime()).toString()  }  })
          }).catch(async () => {});
        }
        }).catch(async () => {});
    },
    async saveData(is_save = false,is_expertise=false) {//is_expertise cờ is_expertise == true khôi phục và ngược lại
      var vm = this;
      //this.submitForm = true;
      await this.validationData(is_save);
      if (Object.entries(this.validationErrors).length === 0) {
        var organization = this.$myConstants.organizationUserLogin();
        var creator_organization_id = (!this.$myConstants.isEmpty(organization.id)) ? organization.id:null;
        //Nếu loại dịch vụ Sửa chữa SP thẩm định thì show popup
        if (is_save == false && is_expertise==false && vm.objectData.check_type_service=='T08' && (vm.objectData.check_result == '0' || (vm.objectData.check_result == '2'  && vm.objectData.check_is_customer_reply == '1' ))){
          //show popup Khôi phục bảo hành sản phẩm
          vm.showConfirmDialogRestore = true;
          return false;
        }
        this.$store.commit('setDataLoading', {content: 'Đang lưu dữ liệu', icon: true});
        this.$store.commit('setLoading', true);
        var params = {
          'type_service': this.objectData.check_type_service,
          'check_presently_damaged': this.objectData.check_presently_damaged,
          'check_result': parseFloat(this.objectData.check_result),
          'check_type_failure_cause_id': this.objectData.check_type_failure_cause_id,
          'check_technical_user_id': this.objectData.check_technical_user_id,
          'check_cause_damage': this.objectData.check_cause_damage,
          'check_proposed_solutions': this.objectData.check_proposed_solutions,
          'check_staff_comments': this.objectData.check_staff_comments,

          'modified_date': this.$myConstants.currentDate(),
         // 'status': this.objectData.status ? 1 : 0,
          'modifier_id': this.$store.getters.fullname.id
        }
        if (this.objectData.check_type_service == vm.$dataCommon.WARRANTY_REPAIR.TYPE_SERVICE.MAINTENANCE){
          params.check_maintenance_period  = this.objectData.check_maintenance_period;
        }
        var content_history_done = '';
        var status_history_done = null;
        var process_status = 0;
        switch(this.objectData.check_result) {
          case '0':
            content_history_done = 'Đã thực hiện dịch vụ';
            status_history_done = 1;
            process_status = 1;
            break;
          case '2':
              if (!vm.$myConstants.isEmpty(vm.objectData.check_is_customer_reply)){
                params.check_is_customer_reply = parseFloat(this.objectData.check_is_customer_reply);
              }
              params.check_content_ask_customer = this.objectData.check_content_ask_customer;
              if (params.check_is_customer_reply == '1'){
                process_status = 1;
                content_history_done = 'Đã thực hiện dịch vụ';
                status_history_done = 1;
              }else {
                process_status = 2;
                content_history_done = 'Khách hàng không đồng ý thực hiện';
                status_history_done = 2;
              }
            break;
          case '1':
            params.check_reason_not_repairing = this.objectData.check_reason_not_repairing;
            process_status = 3;
            content_history_done = 'Không thực hiện và gửi trả khách hàng';
            status_history_done = 3;
            break;
          case '3':
            params.check_reason_cancel_product = this.objectData.check_reason_cancel_product;
            process_status = 4;
            content_history_done = 'Không sửa chữa và đề nghị hủy sản phẩm';
            status_history_done = 4;
            break;
          default:
            // code block
        }
        if (is_save == false){
          params.process_status = process_status;
        }
        //lưu bảng gói dịch vụ
        if (this.objectData.check_result == '0' || (this.objectData.check_result == '2')){
          vm.changeProductService();
          //lưu tổng tiền
          params.service_total_price_service = (!this.$myConstants.isEmpty(this.object_service_park.service_total_price_service)) ? parseFloat(this.object_service_park.service_total_price_service):0;
          params.service_total_discount = (!this.$myConstants.isEmpty(this.object_service_park.service_total_discount)) ? parseFloat(this.object_service_park.service_total_discount):0;
          params.service_total_money_discount = (!this.$myConstants.isEmpty(this.object_service_park.service_total_money_discount)) ? parseFloat(this.object_service_park.service_total_money_discount):0;
          params.service_tax = (!this.$myConstants.isEmpty(this.object_service_park.service_tax)) ? parseFloat(this.object_service_park.service_tax):0;
          params.service_money_tax = (!this.$myConstants.isEmpty(this.object_service_park.service_money_tax)) ? parseFloat(this.object_service_park.service_money_tax):0;
          params.service_total_price_payment = (!this.$myConstants.isEmpty(this.object_service_park.service_total_price_payment)) ? parseFloat(this.object_service_park.service_total_price_payment):0;
         if (is_save == false && (!(this.objectData.check_result == '2' && this.objectData.check_is_customer_reply == '0'))){ // và khách hỏi ý kiến khách hàng -> từ chối thì mới lưu tổng tiền
            //nếu ko phải lưu tạm thì cộng vào tổng tiền
            this.update_total_cost_wr(vm.warranty_repair_id,params.service_total_price_payment)
          }

        }else {
          //ngược lại thì xóa
          var resDataProductService = await vm.getListProductService(this.$route.params.id);
          var list_id =resDataProductService.list_id;
          //xóa list gói dịch vụ
          this.deleteProductService(list_id);
          params.service_total_price_service = 0;
          params.service_total_discount = 0;
          params.service_total_money_discount = 0;
          params.service_tax = 0;
          params.service_money_tax = 0;
          params.service_total_price_payment = 0;
        }
        if (this.files.length > 0){
          var list_image_upload = [];
          for (var h = 0; h < this.files.length; h++) {
            if (!this.$myConstants.isEmpty(this.files[h].old)){
              //hình ảnh cũ ko upload
              var itemOld = this.files[h];
              if (!this.$myConstants.isEmpty(this.files[h].src)){
                delete itemOld['src'];
              }
              delete itemOld['old'];
              list_image_upload.push(itemOld);
            }else {
              var obj_image = await this.$coreService.uploadOneImages(this.files[h]);
              list_image_upload.push(obj_image);
            }
          }
          params.check_list_img_records_confirm = JSON.stringify(list_image_upload);
        }
        var queryUpdate = `
        mutation update_warranty_repair_product_serial_number_multil($core_warranty_repair_product_serial_number_object: core_warranty_repair_product_serial_number_set_input) {
          update_core_warranty_repair_product_serial_number(where: { id: {_eq: "${this.$route.params.id}"}}, _set: $core_warranty_repair_product_serial_number_object) {
            affected_rows
            returning {
              id
            }
          }

        }
          `;
        var variables = {
          "variables": JSON.stringify({
            core_warranty_repair_product_serial_number_object: params
          })
        };
        DataServices.executeQuery(this.modelName, queryUpdate, variables).then(async () => {
          var list_wr_product_serial_number_id = [];
          list_wr_product_serial_number_id.push(vm.$route.params.id);
          var is_restore = false;
          if (is_save == false && is_expertise==true && vm.objectData.check_type_service=='T08' && (vm.objectData.check_result == '0' || (vm.objectData.check_result == '2'  && vm.objectData.check_is_customer_reply == '1' ))){
            //Khôi phục bảo hành sản phẩm
            is_restore = true;
            vm.process_restore_product_serial();
            vm.$coreService.updateHistoryWarrantyRepairProductSn('Đã sửa chữa xong sản phẩm', list_wr_product_serial_number_id, 1, vm.$store.getters.fullname.id);
            //Khôi phục bào hành hủy kế hoạch bảo trì

            //Tìm serail có trạng thái  “Kế hoạch” (giá trị = 0) hoặc “Cần bảo trì” (giá trị = 1)
            var whereKeyMaintence = {
              serial_number_id: {_in: [vm.objectData.serial_number_id]},
              process_status: {_in: [vm.$dataCommon.MAINTENANCE.PROCESS_STATUS.PLAN,vm.$dataCommon.MAINTENANCE.PROCESS_STATUS.MAINTENANCE_NEEDED]}
            }
            var variablesMaintence = {
              where_key: whereKeyMaintence,
              orderBy: {
                parts_number: 'asc',
              }
            }
            var dataMaintence = await DataServices.getList('maintenance', {"variables": JSON.stringify(variablesMaintence)});
            var listMaintence = dataMaintence[Object.keys(dataMaintence)];
            var list_id_maintence = [];
            if (listMaintence.length > 0){
              for (var m=0;m<listMaintence.length;m++){
                list_id_maintence.push(listMaintence[m].id);
              }
              await vm.$coreService.updateStatusMaintence(vm.$dataCommon.MAINTENANCE.PROCESS_STATUS.CANCEL_PLAN_ONLY,list_id_maintence,vm.$store.getters.fullname.id,creator_organization_id);
            }
            //gửi push
            if (vm.objectData.request_return_product_id){
              await vm.$coreService.sendPushNotification('appraisal_warranty_recovery',[vm.objectData.request_return_product_id])
            }
          }
          if (is_save == true){
            vm.$coreService.updateHistoryWarrantyRepairProductSn('Cập nhật thông tin', list_wr_product_serial_number_id, 5, vm.$store.getters.fullname.id);
          }else {
            //nếu khôi phục ko lưu lịch sử
            if (is_restore != true){
              vm.$coreService.updateHistoryWarrantyRepairProductSn(content_history_done, list_wr_product_serial_number_id, status_history_done, vm.$store.getters.fullname.id);
            }
          }
          //Nếu là bảo trì định kỳ thì lưu lại trạng thái
          if (vm.objectData.check_type_service== vm.$dataCommon.WARRANTY_REPAIR.TYPE_SERVICE.MAINTENANCE ){
            if (is_save == false) {
              vm.$coreService.updateStatusMaintence(vm.$dataCommon.MAINTENANCE.PROCESS_STATUS.FOR_MAINTENANCE, [vm.objectData.check_maintenance_period], vm.$store.getters.fullname.id, creator_organization_id);
            }
            if (parseFloat(vm.objectData.check_maintenance_period) != vm.objectData.check_maintenance_period_old){
              //Nếu trạng thái dc thay đổi thì rollback về trạng thái trước khi tiếp nhận
              var variables_maintenance_process = {
                where_key: {
                  maintenance_period_id: {'_eq': vm.objectData.check_maintenance_period_old }
                },
                offset:1,//Lấy trạng thái trước trạng thái hiện tại
                limit:1,
                orderBy: {
                  id: 'desc'
                }
              }
              var data = await DataServices.getList('maintenance_process', {"variables": JSON.stringify(variables_maintenance_process)});
              var list_maintenance_process = data[Object.keys(data)];
              if (list_maintenance_process.length > 0){
                var item_maintenance_process = list_maintenance_process[0];
                var process_status_old = item_maintenance_process.process_status;
                vm.$coreService.updateStatusMaintence(process_status_old, [vm.objectData.check_maintenance_period_old], vm.$store.getters.fullname.id, creator_organization_id);
              }
              if (is_save == true){
                var item_maintence_chancge =  vm.objectData.obj_maintenance_period_change;
                //update trạng thái được đổi thành đang thực hiện nếu trạng thái ko là đang thực hiện
                if (item_maintence_chancge.process_status != vm.$dataCommon.MAINTENANCE.PROCESS_STATUS.PROCESSING){
                  vm.$coreService.updateStatusMaintence(vm.$dataCommon.MAINTENANCE.PROCESS_STATUS.PROCESSING, [vm.objectData.check_maintenance_period], vm.$store.getters.fullname.id, creator_organization_id);
                }
              }
            }
          }

          vm.$store.commit('setLoading', false);
          vm.$router.push({path: '/admin/warranty-repair/function/'+vm.warranty_repair_id});

        }).catch(async () => {
          vm.$toast.add({
            severity: 'error',
            summary: 'Thông báo',
            detail: 'Hệ thống đã gặp sự cố !Xin vui lòng thử lại.',
            life: 3000
          });
          vm.submitForm = false;
        });
      console.log(params)
      } else this.submitForm = false;
    },
    async validationData(is_save) {
      //this.changeProductService();
      //var vm =this;
      this.validationErrors = {};
      /*if (this.list_product_serial.listData.length < 1){
        this.validationErrors['list_product_serial'] = 'Vui lòng thêm sản phẩm vào danh sách';
      }*/
      if (this.$myConstants.isEmpty(this.objectData.check_type_service)){
        this.validationErrors['check_type_service'] = 'Chọn loại dịch vụ';
      }else {
        if (this.objectData.check_type_service == 'T07'){
          if (this.$myConstants.isEmpty(this.objectData.check_maintenance_period)){
            this.validationErrors['check_maintenance_period'] = 'Chọn đợt bảo trì';
          }
        }
      }
      /*if (this.$myConstants.isEmpty(this.objectData.check_type_failure_cause_id)){
        this.validationErrors['check_type_failure_cause_id'] = 'Chọn loại nguyên nhân hư hỏng';
      }*/
      if (this.$myConstants.isEmpty(this.objectData.check_technical_user_id)){
        this.validationErrors['check_technical_user_id'] = 'Chọn nhân viên kỹ thuật';
      }
      if (this.$myConstants.isEmpty(this.objectData.check_technical_user_id)){
        this.validationErrors['check_technical_user_id'] = 'Chọn nhân viên kỹ thuật';
      }
      if (this.$myConstants.isEmpty(this.objectData.check_presently_damaged)){
        this.validationErrors['check_presently_damaged'] = 'Nhập hiện tượng hư hỏng';
      }
      /*if (this.$myConstants.isEmpty(this.objectData.check_cause_damage)){
        this.validationErrors['check_cause_damage'] = 'Nhập nguyên nhân hư hỏng';
      }*/
      /*if (this.$myConstants.isEmpty(this.objectData.check_cause_damage)){
        this.validationErrors['check_cause_damage'] = 'Nhập nguyên nhân hư hỏng';
      }*/
      switch(this.objectData.check_result) {
        case '0':
          if (this.object_service_park.list_product_service_park.length < 1){
            this.validationErrors['list_product_service_park'] = 'Chọn gói dịch vụ cần thêm vào danh sách';
          }/*else {
            //check dữ liệu
            var list_product_service_park = this.object_service_park.list_product_service_park;
            console.log("list_product_service_park:",list_product_service_park)
            for (var i=0;i<list_product_service_park.length;i++){
              if (list_product_service_park[i].is_parent == false){
                if (this.$myConstants.isEmpty(list_product_service_park[i].number)){
                  this.object_service_park.list_product_service_park[i].number_err = "Nhập số lượng";
                  this.validationErrors["number_err"] = '1';
                }
                if (this.$myConstants.isEmpty(list_product_service_park[i].discount)){
                  console.log("66666666")
                  this.object_service_park.list_product_service_park[i].discount_err = "Nhập giảm giá";
                  this.validationErrors["discount_err"] = '1';
                }
                if (this.$myConstants.isEmpty(list_product_service_park[i].money_discount)){
                  this.object_service_park.list_product_service_park[i].money_discount_err = "Nhập tiền giảm giá";
                  this.validationErrors["money_discount_err"] = '1';
                }
              }
            }
          }*/
          break;
        case '1':
          if (this.$myConstants.isEmpty(this.objectData.check_reason_not_repairing)){
            this.validationErrors['check_reason_not_repairing'] = 'Nhập lý do không sửa chữa';
          }
          break;
        case '2':
          if (this.$myConstants.isEmpty(this.objectData.check_content_ask_customer)){
            this.validationErrors['check_content_ask_customer'] = 'Nhập nội dung hỏi ý ';
          }
          if (is_save == false){
            if (this.$myConstants.isEmpty(this.objectData.check_is_customer_reply)){
              this.validationErrors['check_is_customer_reply'] = 'Chọn ý kiến khách hàng';
            }
          }
          if (this.object_service_park.list_product_service_park.length < 1){
            this.validationErrors['list_product_service_park'] = 'Chọn gói dịch vụ cần thêm vào danh sách';
          }
          break;
        case '3':
          if (this.$myConstants.isEmpty(this.objectData.check_reason_cancel_product)){
            this.validationErrors['check_reason_cancel_product'] = 'Nhập lý do đề nghị hủy sản phẩm ';
          }
          break;
        default:
          // code block
          this.validationErrors['check_result'] = 'Chọn kết quả kiểm tra';
      }
      //check nếu trạng thái đã update thì sẽ ko update nữa
      var wr_product_serial_number_id = this.$route.params.id;
      var whereObject = {
        id: {'_eq': wr_product_serial_number_id}
      }
      var check_data =await DataServices.getObjectData('warranty_repair_product_serial_number', whereObject, {id: 'desc'});
      if (check_data.process_status != 0){
        this.$toast.add({
          severity: 'error',
          summary: 'Thông báo',
          detail: 'Thông tin sản phẩm đã được cập nhật.Bạn không thể tiếp tục cập nhật.',
          life: 3000
        });
        this.validationErrors['process_status'] = 'Lỗi';
      }else {
        //check gói dịch vụ trùng không cho thêm
        var list_data_service = this.object_service_park.list_product_service_park;
        var check_duplicate = [];
        if (this.objectData.check_result == '0' || (this.objectData.check_result == '2')) {
          for (var i = 0; i < list_data_service.length; i++) {
            if (list_data_service[i].is_parent == true) {
              if (check_duplicate.includes(list_data_service[i].service_pack_id)) {
                this.$toast.add({
                  severity: 'error',
                  summary: 'Thông báo',
                  detail: 'Gói dịch vụ bị trùng.Vui lòng kiểm tra lại.',
                  life: 3000
                });
                this.validationErrors['process_status'] = 'Lỗi';
                break;
              }
              check_duplicate.push(list_data_service[i].service_pack_id);
            }
          }
        }
      }

      if (!(Object.entries(this.validationErrors).length === 0)) {
        //Nếu tồn tại lỗi thì force để load validator mượt
        this.$forceUpdate();
      }
    },
    async getListProductService(wr_product_serial_number_id) {
      var variables = {
        where_key: {
          status: {'_in': [1]},
          warranty_repair_product_serial_number_id: {_eq: wr_product_serial_number_id}
        },
        orderBy: {
          id: 'desc',
        }
      }
      var data = await DataServices.getList('warranty_repair_product_sn_has_service_park', {"variables": JSON.stringify(variables)});
      var list = data[Object.keys(data)];
      var list_service_park_id = [];
      var list_id = [];
      var list_id_tmp = [];
      //var list_map_tmp = [];
      var service_pack_retail =null;
      var list_map_service_pack = {};
      for (var p = 0; p < list.length; p++) {
        var service_pack_id_check = parseFloat(list[p].service_pack_id);
        if (service_pack_id_check != -1){
          list_id_tmp.push(list[p].service_pack_id);
        }else {
          service_pack_retail = parseFloat(list[p].service_pack_id);
        }
        list_map_service_pack["k_"+service_pack_id_check]=list[p];
      }
      //push vat tu lẻ vào cuối mảng
      if (service_pack_retail == -1){
        list_id_tmp.push(service_pack_retail);
      }
      list = [];
      for (var t = 0; t < list_id_tmp.length; t++) {
        var service_pack_id_map = list_id_tmp[t];
        list.push(list_map_service_pack["k_"+service_pack_id_map]);
      }
      console.log("listlist:",list)
      var list_retail_supplies_id =[];
      for (var i = 0; i < list.length; i++) {
        var service_pack_id = (!this.$myConstants.isEmpty(list[i].service_pack_id)) ? list[i].service_pack_id : null;
        var obj_service_park = (!this.$myConstants.isEmpty(list[i].info_service_pack)) ? JSON.parse(list[i].info_service_pack) : null;
        var obj_edit_id = (!this.$myConstants.isEmpty(list[i].id)) ? parseFloat(list[i].id) : 0;
        this.object_service_park.list_product_service_park_init_id.push(obj_edit_id);//lưu id khởi taọ lúc đầu
        var lable_parent = '';
        if (parseFloat(service_pack_id) ==-1){
          lable_parent='Vật tư lẻ';
        }else {
          lable_parent=obj_service_park.code + ' - ' + obj_service_park.name;
        }
        var obj_data_service_park = {
          obj_edit_id: obj_edit_id,
          lable: lable_parent,
          unit_name: '',
          is_free: (list[i].is_free == 1) ? true : false,
          unit_price: '',
          unit_price_text: '',
          number: '',
          discount: '',
          money_discount: '',
          total_price: (!this.$myConstants.isEmpty(list[i].total_price)) ? parseFloat(list[i].total_price) : 0,
          service_pack_id: service_pack_id,
          is_parent: true,
          info_data: obj_service_park,
          service_pack_service_supplies_id: 0,
          service_supplies_id: 0,
          number_err: '',
          discount_err: '',
          money_discount_err: '',
        }
        this.object_service_park.list_product_service_park.push(obj_data_service_park);//unshift ko dùng push theo thứ tự query
        list_service_park_id.push(service_pack_id);
        list_id.push(obj_edit_id);

        var list_service_supplies = (list[i].arr_wr_product_serial_service_supplies) ? list[i].arr_wr_product_serial_service_supplies : [];
        for (var j = 0; j < list_service_supplies.length; j++) {
          console.log("list_service_supplies[j]:",list_service_supplies[j])
          var obj_service_supplies = (!this.$myConstants.isEmpty(list_service_supplies[j].info_service_supplies)) ? JSON.parse(list_service_supplies[j].info_service_supplies) : null;
          var service_unit_map = this.object_service_park.service_unit_map_data[obj_service_supplies.unit];
          var obj_data_service_supplies = {
            obj_edit_id: (!this.$myConstants.isEmpty(list_service_supplies[j].id)) ? parseFloat(list_service_supplies[j].id) : 0,
            lable: obj_service_supplies.code + ' - ' + obj_service_supplies.name,
            unit_name: (!this.$myConstants.isEmpty(service_unit_map) ? service_unit_map : ''),
            is_free: (list_service_supplies[j].is_free == 1) ? true : false,
            unit_price: (!this.$myConstants.isEmpty(obj_service_supplies.unit_price)) ? parseFloat(obj_service_supplies.unit_price) : 0,
            unit_price_text: (!this.$myConstants.isEmpty(obj_service_supplies.unit_price)) ? this.$myConstants.numberFormat(parseFloat(obj_service_supplies.unit_price), 0, '', '.') : '0',
            number: (!this.$myConstants.isEmpty(list_service_supplies[j].number)) ? parseFloat(list_service_supplies[j].number) : 0,
            discount: (!this.$myConstants.isEmpty(list_service_supplies[j].discount)) ? parseFloat(list_service_supplies[j].discount) : 0,
            money_discount: (!this.$myConstants.isEmpty(list_service_supplies[j].money_discount)) ? parseFloat(list_service_supplies[j].money_discount) : 0,
            total_price: (!this.$myConstants.isEmpty(list_service_supplies[j].total_price)) ? parseFloat(list_service_supplies[j].total_price) : 0,
            service_pack_id: service_pack_id,
            is_parent: false,
            info_data: obj_service_supplies,
            service_pack_service_supplies_id: (!this.$myConstants.isEmpty(list_service_supplies[j].service_pack_service_supplies_id)) ? list_service_supplies[j].service_pack_service_supplies_id : 0,
            service_supplies_id: (!this.$myConstants.isEmpty(obj_service_supplies.id)) ? obj_service_supplies.id : 0,
            number_err: '',
            discount_err: '',
            money_discount_err: '',
          }
          this.object_service_park.list_product_service_park.push(obj_data_service_supplies);//unshift ko dùng push theo
          console.log(" this.object_service_park.list_product_service_park:", this.object_service_park.list_product_service_park)
          if (service_pack_id ==-1){
            list_retail_supplies_id.push(list_service_supplies[j].service_pack_service_supplies_id);
          }
        }

      }
      return {
        list_service_park_id:list_service_park_id,
        list_id:list_id,
        list_retail_supplies_id:list_retail_supplies_id,
      };
    },
    async changeProductService() {
      var organization = this.$myConstants.organizationUserLogin();
      var creator_organization_id = (!this.$myConstants.isEmpty(organization.id)) ? organization.id:null;
      //var vm = this;
      var list_data_service = this.object_service_park.list_product_service_park;
      if (list_data_service.length > 0){
        list_data_service.reverse();//đảo ngược mảng lại những item thêm trước sẽ insert vào db trước
      }
      var map_data_service = {};
      var list_wr_product_sn_has_service_park_id = [];//lấy danh sách id warranty_repair_product_sn_has_service_park tồn tại
      console.log("list_data_service:",list_data_service)
      for (var i=0;i<list_data_service.length;i++){
        var key_map = "key_"+list_data_service[i].service_pack_id;//set key bằng chuỗi để ko thay đổi thứ tự thêm vào array
        if (this.$myConstants.isEmpty(map_data_service[key_map])){
          //nếu chưa tồn tại thì khởi tạo object
          map_data_service[key_map] = {};
        }
        if (list_data_service[i].is_parent== true){
          var objectDataServicePark = {
            warranty_repair_product_serial_number_id:parseFloat(this.$route.params.id),
            service_pack_id:parseFloat(list_data_service[i].service_pack_id),
            info_service_pack:(!this.$myConstants.isEmpty(list_data_service[i].info_data)) ? JSON.stringify(list_data_service[i].info_data):null,
            is_free:parseFloat(list_data_service[i].is_free),
            total_price:parseFloat(list_data_service[i].total_price),
            modified_date: this.$myConstants.currentDate(),
          };
          if (parseFloat(list_data_service[i].service_pack_id) ==-1){
            objectDataServicePark.status = 1;
            objectDataServicePark.created_date = this.$myConstants.currentDate();
          }else {
            if (!this.$myConstants.isEmpty(list_data_service[i].obj_edit_id)){
              objectDataServicePark.id = list_data_service[i].obj_edit_id;
              list_wr_product_sn_has_service_park_id.push(list_data_service[i].obj_edit_id);
            }else {
              objectDataServicePark.status = 1;
              objectDataServicePark.created_date = this.$myConstants.currentDate();
            }
          }
          objectDataServicePark.is_free = 0;
          if (list_data_service[i].is_free){
            if (list_data_service[i].is_free == true){
              objectDataServicePark.is_free = 1;
            }
          }
          map_data_service[key_map].item_parrent = objectDataServicePark;
        }else {
          var objDataServiceSupplies = {
            service_pack_service_supplies_id:parseFloat(list_data_service[i].info_data.id),
            service_supplier_id:list_data_service[i].info_data.id,
            info_service_supplies:(!this.$myConstants.isEmpty(list_data_service[i].info_data)) ? JSON.stringify(list_data_service[i].info_data):null,
            number:parseFloat(list_data_service[i].number),
            discount:parseFloat(list_data_service[i].discount),
            money_discount:parseFloat(list_data_service[i].money_discount),
            total_price:parseFloat(list_data_service[i].total_price),
            modified_date: this.$myConstants.currentDate(),
            modifier_id: this.$store.getters.fullname.id,
            modified_organization_id: creator_organization_id,
          };
          if (parseFloat(list_data_service[i].service_pack_id) ==-1){
            objDataServiceSupplies.status = 1;
            objDataServiceSupplies.created_date = this.$myConstants.currentDate();
          }else {
            if (!this.$myConstants.isEmpty(list_data_service[i].obj_edit_id)){
              objDataServiceSupplies.id = list_data_service[i].obj_edit_id;
            }else {
              objDataServiceSupplies.status = 1;
              objDataServiceSupplies.created_date = this.$myConstants.currentDate();
            }
          }

          objDataServiceSupplies.is_free = 0;
          if (list_data_service[i].is_free){
            if (list_data_service[i].is_free == true){
              objDataServiceSupplies.is_free = 1;
            }
          }
          if (this.$myConstants.isEmpty(map_data_service[key_map].list_service_supplies)){
            //Nếu chưa tồn tại thì khởi tạo
            map_data_service[key_map].list_service_supplies = [];
          }
          map_data_service[key_map].list_service_supplies.push(objDataServiceSupplies);
        }
      }

      var list_product_service_park_init_id = this.object_service_park.list_product_service_park_init_id;
      console.log("list_product_service_park_init_id",list_product_service_park_init_id);
      console.log("list_wr_product_sn_has_service_park_id",list_wr_product_sn_has_service_park_id);
      //get phần tử của mảng list_product_service_park_init_id khác với list_wr_product_sn_has_service_park_id
      var list_id_delete = list_product_service_park_init_id.filter(x => !list_wr_product_sn_has_service_park_id.includes(x));
      if (list_id_delete.length > 0){
        await this.deleteProductService(list_id_delete);
      }
      /*var tests = 1;
     if (tests == 1){
       //list_data_service.reverse();
       console.log("list_data_servicelist_data_service:",map_data_service)
       return false;
     }*/
      //insert data
      console.log("map_data_servicemap_data_service:",map_data_service)
      for (const [key, value] of Object.entries(map_data_service)) {
        console.log(key);
        var params = value.item_parrent;
        var service_pack_id_check = params.service_pack_id;
        params.arr_wr_product_serial_service_supplies = {data: value.list_service_supplies};
        if (parseFloat(service_pack_id_check) ==-1){
          await DataServices.insertData('warranty_repair_product_sn_has_service_park', {"variables": JSON.stringify({objects: params})}).then(async () => {
            //vm.$router.push({path: '/admin/service-park'});
          }).catch(async () => {
          });
        }else {
          if (!this.$myConstants.isEmpty(value.item_parrent.id)){
            //Trường hợp edit
            this.updateProductService(value);
          }else {
            //trường hợp thêm mới
            await DataServices.insertData('warranty_repair_product_sn_has_service_park', {"variables": JSON.stringify({objects: params})}).then(async () => {
              //vm.$router.push({path: '/admin/service-park'});
            }).catch(async () => {
            });
          }
        }
      }
    },
    async deleteProductService(list_id_delete){
      //update xóa item
      var queryUpdateStatus = `
        mutation update_core_warranty_repair_product_sn_has_service_park_multil($core_warranty_repair_product_sn_has_service_park_object: core_warranty_repair_product_sn_has_service_park_set_input,$where_warranty_repair_product_sn_has_service_park: core_warranty_repair_product_sn_has_service_park_bool_exp!,$core_warranty_repair_product_sn_has_service_supplies_object: core_warranty_repair_product_sn_has_service_supplies_set_input,$where_core_warranty_repair_product_sn_has_service_supplies: core_warranty_repair_product_sn_has_service_supplies_bool_exp!) {
          update_core_warranty_repair_product_sn_has_service_park(where: $where_warranty_repair_product_sn_has_service_park, _set: $core_warranty_repair_product_sn_has_service_park_object) {
            affected_rows
            returning {
              id
            }
          }
          update_core_warranty_repair_product_sn_has_service_supplies(where: $where_core_warranty_repair_product_sn_has_service_supplies, _set: $core_warranty_repair_product_sn_has_service_supplies_object) {
            affected_rows
            returning {
              id
            }
          }
        }
          `;
      var variablesUpdateStatus = {
        "variables": JSON.stringify({
          core_warranty_repair_product_sn_has_service_park_object: {status:0},
          where_warranty_repair_product_sn_has_service_park: {id: {_in: list_id_delete}},
          core_warranty_repair_product_sn_has_service_supplies_object: {status:0},
          where_core_warranty_repair_product_sn_has_service_supplies: {warranty_repair_product_sn_has_service_park_id: {_in: list_id_delete}},
        })
      };
      DataServices.executeQuery('warranty_repair_product_sn_has_service_park', queryUpdateStatus, variablesUpdateStatus).then(async () => {
      }).catch(async () => {
      });
    },
    async updateProductService(params){
      var queryUpdateProductService = `
        mutation update_core_warranty_repair_product_sn_has_service_park_multil($core_warranty_repair_product_sn_has_service_park_upsert:[core_warranty_repair_product_sn_has_service_park_insert_input!]!,$core_warranty_repair_product_sn_has_service_supplies_upsert:[core_warranty_repair_product_sn_has_service_supplies_insert_input!]!) {
          insert_core_warranty_repair_product_sn_has_service_park (
          objects: $core_warranty_repair_product_sn_has_service_park_upsert,
          on_conflict: {
            constraint: core_warranty_repair_product_sn_has_service_park_pkey,
            update_columns: [warranty_repair_product_serial_number_id,service_pack_id,info_service_pack,is_free,total_price,modified_date]
          }
        ) {
          returning {
            id
          }
        }
         insert_core_warranty_repair_product_sn_has_service_supplies (
          objects: $core_warranty_repair_product_sn_has_service_supplies_upsert,
          on_conflict: {
            constraint: core_warranty_repair_product_sn_has_service_supplies_pkey,
            update_columns: [service_pack_service_supplies_id,info_service_supplies,is_free,number,discount,money_discount,total_price,modified_date,service_supplier_id,modified_organization_id,modifier_id]
          }
        ) {
          returning {
            id
          }
        }

        }
          `;
      var item_parrent = params.item_parrent;
      if (item_parrent.arr_wr_product_serial_service_supplies){
        delete item_parrent['arr_wr_product_serial_service_supplies'];
      }
      var arr_wr_product_serial_service_supplies = params.list_service_supplies;
      var variablesUpdateStatus = {
        "variables": JSON.stringify({
          core_warranty_repair_product_sn_has_service_park_upsert: item_parrent,
          core_warranty_repair_product_sn_has_service_supplies_upsert: arr_wr_product_serial_service_supplies,
        })
      };
      DataServices.executeQuery('warranty_repair_product_sn_has_service_park', queryUpdateProductService, variablesUpdateStatus).then(async () => {
      }).catch(async () => {
      });
    },
    removeImg(index) {
      this.files.splice(index, 1);
      if (this.files.length == 0) this.files = [];
    },
    openFile() {
      this.$refs.files.click();
    },
    chooseFile($event) {
      $event.preventDefault();
      $event.stopPropagation();
      var checkFile = false;
      var arrFiles = [];
      var fileSelects = $event.target.files || $event.dataTransfer.files;
      if (!fileSelects.length)
        return;
      for (let index = 0; index < fileSelects.length; index++) {
        const file = fileSelects[index];
        if (this.$myConstants.isImage(file.type)) {
          file.source = file;
          file.src = window.URL.createObjectURL(file);
          file.objectURL = window.URL.createObjectURL(file);
          arrFiles.push(file);
        } else {
          checkFile = true;
          break;
        }
      }
      if (checkFile) {
        this.$toast.add({ severity: 'error', summary: 'Thông báo', detail: 'Sai định dạng file', life: 3000 })
      } else {
        this.files = this.files.concat.apply(this.files, arrFiles);
      }
    },
  }
}
</script>
<style lang="scss">
.title_group{
  font-weight: 700; font-style: normal; font-size: 16px!important;color: #333333;
}

.p-inputnumber-buttons-stacked {
  .p-inputnumber-button-group {
    .p-button.p-button-icon-only { padding: 0 !important; }
  }
}
.box-top-list{border: 1px solid #ccc; padding: 10px;
  span{font-size: 25px; text-align: left; display: inline-block;}
  .right-button{float: right;
    span{font-size: 14px;}
    .p-button{border-radius: 5px; min-width: 100px;
      &.btn-custom{ margin-left: 10px;}
      span{text-align: center;}
    }
  }
}
.list-data{border: 1px solid #ccc; border-top: 0 none; padding: 20px;
  .unit-custom{text-align: right;
    label{margin-bottom: 0; margin-top: 10px;}
  }
  .box-qrcode-product{margin-top: 20px;}
  .box-img-product{margin-top: 40px;}
}
.custom-qr-code {
  .qr-custom{width: 150px !important; height: 150px !important;}
}
.group_radio_button {
  margin-left: 0px;
  .radio_product_apply {
    position: relative;

    .radio_lable_product_apply {
      position: absolute;
      left: 30px;
      top: 3px;
      font-size: 14px;
    }
  }

  .p-radiobutton .p-radiobutton-box .p-radiobutton-icon{
    color: #007ad9;
  }
  .p-radiobutton .p-radiobutton-box.p-highlight{
    background: #ffffff;
  }
}


.box_add_option {
  background-color: rgba(242, 242, 242, 1);
  border-radius: 10px;
  margin: 0px;
  padding: 15px;

  .box_input {
    padding: 0px;
    width: calc(100% - 120px);

    .box_title {
      position: relative;
      height: 20px;
      margin-bottom: 2px;
      .title_input {
        font-size: 14px;
        position: absolute;
        left: 0px;
      }

      .add_service_supplies {
        font-size: 14px;
        position: absolute;
        right: 0px;
        font-family: 'Arial Italic', 'Arial';
        font-weight: 400;
        font-style: italic;
        cursor: pointer;
      }
    }
  }

  .add_btn_data {
    position: relative;
    width: 100px;
    height: 40px;
    background: inherit;
    background-color: rgba(0, 153, 255, 1);
    border: none;
    border-radius: 5px;
    margin-right: 10px;
    margin-left: 10px;
    margin-top: 20px;

    .style_icon_add {
      position: absolute;
      margin-top: auto;
      margin-bottom: auto;
      top: 0;
      left: 0;
      bottom: 0;
      margin-left: 14px;
    }

    .style_text {
      position: absolute;
      margin-top: auto;
      margin-bottom: auto;
      top: 0;
      bottom: 0;
      height: fit-content;
      font-family: 'Arial Bold', 'Arial';
      font-weight: 700;
      font-style: normal;
      font-size: 14px;
      color: #FFFFFF;
    }
  }
}

.form-info{
  .message_err{
    text-align: right!important;font-weight: 400; font-style: italic; color: #FF0000; font-size: 14px;margin-bottom: 0px
  }
  .p-field{ padding: 10px;
    &:nth-child(n) {background: #E4E4E4;}
    &:nth-child(2n) {background: #fff;}
    label{ width: 200px; margin: 0;}
    .box-status{
      position: relative;
      background-color: rgba(153, 0, 204, 1);
      border-radius: 5px;
      text-align: center;
      //midle vertical
      display: inline-block;
      vertical-align: middle;
      padding-left: 9px;
      padding-right: 10px;
      padding-top: 2px;
      padding-bottom: 2px;
      .style-text-status{
        font-family: 'Arial Bold', 'Arial';
        font-weight: 700;
        font-style: normal;
        font-size: 14px;
        color: #FFFFFF;
      }
    }
    .box-value{
      width: calc(100% - 220px);//căn chỉnh để xuống thẳng hàng
      display: inline-block;
    }
  }
  .box-button{
    margin-top: 10px;
    .btn-done{
      width: 120px;
      float: left;
      margin-right: 32px;
      background: linear-gradient(180deg, rgba(66, 139, 202, 1) 0%, rgba(66, 139, 202, 1) 0%, rgba(45, 108, 162, 1) 100%, rgba(45, 108, 162, 1) 100%) !important;
      border: 1px solid #428bca;
      font-family: 'Arial Bold', 'Arial';
      font-weight: 700;
      font-style: normal;
      font-size: 14px;
      color: #FFFFFF;
      line-height: 24px;
    }
    .btn-false-report{
      width: 120px;
      background: linear-gradient(180deg, rgb(240, 173, 78) 0%, rgba(240, 173, 78, 1) 0%, rgba(235, 147, 22, 1) 100%, rgba(235, 147, 22, 1) 100%);
      border: 1px solid #F0AD4E;
      font-family: 'Arial Bold', 'Arial';
      font-weight: 700;
      font-style: normal;
      font-size: 14px;
      color: #FFFFFF;
      line-height: 24px;
    }
  }
}

.box-list-img{ margin: 0;
  .images-wrapper {
    .item-img {margin-bottom: 10px;
      .item{position: relative; text-align: center; width: 100%; margin: 0 auto;
        .remove-icon{cursor: pointer; position: absolute; right: -7px; top: -8px; color: #fff; background: #f00; width: 15px; height: 15px; overflow: hidden; border-radius: 50%;
          span{color: #fff; font-size: 8px; position: relative;top: -7.5px; left: 0px; font-weight: bold;}
        }
        .img {padding-top: 6px;
          img{max-width: 100%; height: auto;}
        }
      }
    }
  }
}
.images-wrapper { display: flex;
  .image {height: 150px; width: 100%; display: block; margin-right: 20px; cursor: pointer; background-size: cover;
    &:last-child{margin: 0;}
  }
}
.table-subtable{
  .p-filter-column{
    display: none;
  }
}
.dialog-comfirm-common{
  width: 434px;
  .p-dialog-header{
    padding-bottom: 4px; padding-top: 4px;
  }
  .box_body_popup{
    width: 100%;
    .p_title_1{
      text-align: center;margin-bottom: 0px;
    }
    .p_title_2{
      text-align: center;
    }
    .box_btn{
      text-align: center
    }
  }
}
.list_service_park_price{
  .style_header,.style_footer {
    background-color: rgba(228, 228, 228, 1) !important;
  }
  .style_header{
    font-weight: 700 !important;
  }
  .style_footer{
    .header_footer{
      text-align: right;margin-right: 109px
    }
    .value_common_footer{
      text-align: right;
      .style_value{
        font-weight: 400!important;
      }
    }
  }
}
.box_radio_reply{
  float: right;
  .p-field-radiobutton{
    position: relative!important;width: 100%!important;
  .style_radio{
    position: absolute;left: 0px;
  }
  .lable_reply{
    position: absolute; left: 24px; top: -2px;
  }
    .p-radiobutton .p-radiobutton-box .p-radiobutton-icon{
      color: #007ad9;
    }
    .p-radiobutton .p-radiobutton-box.p-highlight{
      background: #ffffff;
    }
  }
}
</style>
<style>
.style_input_number_common input{
  text-align: right;
}
.style_input_common input[disabled="disabled"], textarea[disabled="disabled"] {
  font-weight: 700;
  font-style: normal;
  font-size: 13px;
  text-decoration: none;
  color: #000000;
  background: none !important;
  opacity: 0.9 !important;
}
</style>